/* syk-pdp — productpagina-sectie runtime. Config/data uit window.SP_* (zie de sectie). Vanilla, defensief. */
(function () {
  /* levertijd-vangnet in de drawer (melding eigenaar: regel toonde alleen "128 cm ·"): het thema
     rendert per regel een VERBORGEN standaardtekst (instelling default_product_deliverytime_in_stock)
     + een lege .custom-deliverytime die de levertijd-API vult — maar de API kent niet elke sku
     (deliveryDate null, live gemeten voor 5055294866677/84) en dan bleef de regel leeg. Zolang de
     API-tekst leeg is de standaardtekst tonen; vult de API alsnog, dan wint die (idempotent in
     beide volgordes; classList-writes zijn geen childList/characterData-mutatie, dus geen lus). */
  if (!window.__sykDrawerVangnet) {
    window.__sykDrawerVangnet = true;
    var sykDrawerVangnet = function () {
      [].forEach.call(document.querySelectorAll("#cart .custom-deliverytime"), function (cd) {
        var ouder = cd.parentNode;
        if (!ouder) return;
        var std = null;
        [].forEach.call(ouder.children, function (k) { if (k !== cd && /\bstrong\b/.test(String(k.className))) std = k; });
        if (!std) return;
        if (cd.textContent.trim()) std.classList.add("hidden");
        else std.classList.remove("hidden");
      });
    };
    (function () {
      var box = document.getElementById("cart");
      if (!box || !window.MutationObserver) return;
      var t2;
      try {
        new MutationObserver(function () { clearTimeout(t2); t2 = setTimeout(sykDrawerVangnet, 900); })
          .observe(box, { childList: true, subtree: true, characterData: true });
      } catch (e) {}
      setTimeout(sykDrawerVangnet, 1200);
    })();
  }
  if (!document.querySelector('.syk-pdp') || window.__sykPdpInit) return;
  window.__sykPdpInit = true;
  var CFG = window.SP_CFG || {};
  /* i18n (SP_CFG.locale + SP_CFG.i18n uit de graft, per shoptaal/Market); NL-fallbacks zodat een oudere graft blijft werken */
  var LOC = CFG.locale || 'nl-NL';
  var I18 = CFG.i18n || {};
  var DSUF = (I18.suffix == null ? ' in huis' : I18.suffix);
  var VARS = window.SP_VARS || [];
  var BULK = "https://econcepts.bemashopping.com/delivery/bulk";
  var STAFFEL_URL = "https://econcepts.bemashopping.com/delivery";
  var byId = {};
  VARS.forEach(function (v) { byId[String(v.id)] = v; });
  var DELIV = null; /* levertijd-map per sku, gevuld na de bulk-call */

  /* paginabreed gescoped op .syk-pdp: werkt voor de losse sectie én voor losse blokken in de thema-sectie */
  function $(s, c) { return c ? c.querySelector(s) : document.querySelector('.syk-pdp ' + s); }
  function $all(s, c) { return [].slice.call(c ? c.querySelectorAll(s) : document.querySelectorAll('.syk-pdp ' + s)); }
  function sod(d) { var x = new Date(d); x.setHours(0, 0, 0, 0); return x; }
  function diffDays(d) { return Math.round((sod(d) - sod(new Date())) / 86400000); }
  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
  function dateLong(d) { return d.toLocaleDateString(LOC, { weekday: 'long', day: 'numeric', month: 'long' }); }
  function dateShort(d) { return d.toLocaleDateString(LOC, { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, ''); }
  function etaShort(d) { var n = diffDays(d); if (n <= 0) return (I18.sToday || 'Vandaag'); if (n === 1) return (I18.sTomorrow || 'Morgen'); return cap(dateShort(d)); }
  /* legenda-datum (wens eigenaar 27-07): t/m 5 dagen na vandaag de dagnaam VOLUIT ('Donderdag') —
     binnen die horizon is een dagnaam uniek en concreter dan 'Do 30 juli'; daarna kort mét datum. */
  function legDag(d) { var n = diffDays(d); if (n <= 0) return (I18.sToday || 'Vandaag'); if (n === 1) return (I18.sTomorrow || 'Morgen'); if (n <= 5) return dayName(d); return cap(dateShort(d)); }
  function inHuis(d) {
    var n = diffDays(d);
    if (n <= 0) return (I18.today || 'Vandaag in huis');
    if (n === 1) return (I18.tomorrow || 'Morgen in huis');
    var tpl = I18.dateTpl || '{d} in huis';
    var ds = dateLong(d); if (tpl.indexOf('{d}') === 0) ds = cap(ds); /* alleen kapitaliseren als de datum de zin opent */
    return tpl.replace('{d}', ds);
  }
  function fmtEUR(n) { try { return n.toLocaleString(LOC, { style: 'currency', currency: 'EUR' }); } catch (e) { return '€ ' + n.toFixed(2).replace('.', ','); } }
  function dayName(d) { return cap(d.toLocaleDateString(LOC, { weekday: 'long' })); }

  /* ---- CUTOFF: tot hoe laat gaat de bestelling vandaag nog mee? (endpoint eigenaar 30-09) ----
     levertijden.json geeft per MERK (= product.vendor) de tijd waarop de besteldag bij die
     leverancier sluit, plus een 'default' voor de eigen voorraad. Bevestigd door de eigenaar:
     ligt het artikel op EIGEN VOORRAAD dan telt de algemene tijd; moeten we het bij de LEVERANCIER
     bestellen, dan de merktijd. Dat is precies het verschil tussen trap 0 en trap 1+ van de staffel.
     BEWUST GEEN BEZORGBELOFTE. De verzendmethodes (PostNL/Trunkrs/Thuisbezorging) hebben in
     econcepts eigen tijden die NIET in dit bestand staan. De klantdeadline is
     min(leverancier, verzendmethode) en wij kennen alleen de eerste helft. Uit min(a,b) <= a volgt
     wel de omgekeerde richting: is a verstreken, dan is de snelste route zeker weg. Daarom zeggen
     we alleen iets over onze eigen VERWERKING ('vandaag nog in behandeling'), nooit 'morgen in huis'. */
  var CUTOFF_URL = 'https://retourneren.e-carnavalskleding.nl/levertijden.json';
  var CUTOFF = null, cutoffVlucht = null, cutoffOpgehaald = 0;
  function cutoffLaad() {
    /* NIET dag-cachen zoals de leverdatums: de ochtend- en middagrun kunnen de tijd BINNEN dezelfde
       dag wijzigen. In het geheugen houden en na 5 minuten opnieuw ophalen; de server zet zelf
       cache-control max-age=60, dus vaker vragen kost vrijwel niets. Fouten worden niet gecachet. */
    var nu = new Date().getTime();
    if (CUTOFF && (nu - cutoffOpgehaald) < 300000) return Promise.resolve(CUTOFF);
    if (cutoffVlucht) return cutoffVlucht;
    cutoffVlucht = fetch(CUTOFF_URL, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        cutoffVlucht = null;
        if (j && typeof j === 'object' && j['default']) { CUTOFF = j; cutoffOpgehaald = new Date().getTime(); }
        return CUTOFF;
      })
      .catch(function () { cutoffVlucht = null; return CUTOFF; });
    return cutoffVlucht;
  }
  /* De winkelklok is Europe/Amsterdam; new Date().getHours() is de klok van de BEZOEKER. Een
     Britse bezoeker om 10:30 zit op 11:30 in Amsterdam en zou een al gesloten besteldag als open
     zien (Funny Fashion sluit om 11:00 = 5.369 producten). Intl met timeZone regelt meteen de
     zomertijd; een vaste +02:00 zou op 25 oktober 2026 breken. */
  var WDAG = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };
  function klokAmsterdam() {
    /* Uur EN weekdag uit DEZELFDE aanroep. Twee aanroepen mengen (of de weekdag uit
       new Date().getDay() halen) zou de bug terugbrengen die deze functie juist voorkomt: een
       bezoeker in Tokio zit al op de volgende dag terwijl het in Amsterdam nog gisteren is.
       GEEN stille terugval op de bezoekersklok: kan Intl de zone niet, dan geven we null terug en
       zwijgt de cutoff-regel. Een verkeerde deadline is erger dan geen deadline. */
    try {
      var dl = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', hour: '2-digit', minute: '2-digit', hourCycle: 'h23', weekday: 'short' }).formatToParts(new Date());
      var u = null, m = null, w = null;
      dl.forEach(function (x) {
        if (x.type === 'hour') u = parseInt(x.value, 10);
        if (x.type === 'minute') m = parseInt(x.value, 10);
        if (x.type === 'weekday') w = WDAG[x.value];
      });
      if (u !== null && m !== null && w && !isNaN(u) && !isNaN(m)) return { min: (u % 24) * 60 + m, dag: w };
    } catch (e) {}
    return null;
  }
  function minutenVan(t) {
    var m = /^(\d{1,2}):(\d{2})$/.exec(String(t == null ? '' : t));
    if (!m) return null;
    var u = parseInt(m[1], 10), mi = parseInt(m[2], 10);
    if (u > 23 || mi > 59) return null; /* 24:00 / 99:99 zou de zin permanent op 'nog open' zetten */
    return u * 60 + mi;
  }
  /* tijdweergave per taal: fr schrijft 15h00, de rest 15:00 (het 'Uhr'/'las'/'le' zit in de zin zelf) */
  function tijdTekst(t) { return (String(LOC).slice(0, 2) === 'fr') ? String(t).replace(':', 'h') : String(t); }
  /* ---- BEZORGING VANDAAG (eigenaar 06-10) ----
     Met Trunkrs-avondlevering (levertijd 0 dagen) kan eigen voorraad dezelfde dag bezorgd worden,
     mits besteld vóór een vaste tijd (instelling syk_vandaag_cutoff, standaard 10:45). econcepts zet
     de eigen voorraad tot die tijd op VANDAAG; gemeten 06-10: om 10:42 nog vandaag, om 10:52 morgen.
     Daarvóór zei de badge 'Voor 23:59 uur besteld = vandaag in huis' — de vaste 23:59 klopte daar
     niet. Na de besteltijd behandelen we 'vandaag' als de eerstvolgende werkdag, ook als econcepts
     nog niet is bijgewerkt: anders zou de site enkele minuten een verlopen belofte tonen. */
  var VD = (function () {
    var el = document.querySelector('[data-vd-tijd]');
    var tijd = el ? String(el.getAttribute('data-vd-tijd') || '').trim() : '';
    if (minutenVan(tijd) === null) tijd = '10:45';
    return {
      tijd: tijd,
      lang: (el && el.getAttribute('data-vd-lang')) || 'V\u00f3\u00f3r {t} besteld = vanavond in huis',
      kort: (el && el.getAttribute('data-vd-kort')) || 'Vanavond in huis'
    };
  })();
  function vandaagNogMogelijk() {
    var k = klokAmsterdam(), m = minutenVan(VD.tijd);
    return (!k || m === null) ? true : k.min < m;  /* klok onbekend: vertrouw de datum van econcepts */
  }
  function vandaagTekst() { return VD.lang.replace('{t}', tijdTekst(VD.tijd)); }
  /* line-item-eigenschappen _deliverydate/_deliverystamp vullen (melding eigenaar 10-07: sinds onze
     eigen levertijd-render vulde de thema-fetchDeliverytimes deze verborgen inputs niet meer, dus
     kwamen ze leeg in de order). EXACT hetzelfde formaat als het thema (custom-async.js): de datum-
     string is 'Vandaag'/'Morgen'/volledige datum ('maandag 26 januari'), de stamp de ms-timestamp. */
  function deliverStr(d) {
    if (!d || isNaN(d.getTime())) return '';
    var n = diffDays(d);
    if (n <= 0) return (I18.sToday || 'Vandaag');
    if (n === 1) return (I18.sTomorrow || 'Morgen');
    return dateLong(d);
  }
  function fillDelivProps(d) {
    var ds = deliverStr(d);
    var ts = (d && !isNaN(d.getTime())) ? d.getTime() : '';
    [].forEach.call(document.querySelectorAll('input[name="properties[_deliverydate]"]'), function (el) { el.value = ds; });
    [].forEach.call(document.querySelectorAll('input[name="properties[_deliverystamp]"]'), function (el) { el.value = ts; });
  }
  /* ---- PRE-ORDER (melding eigenaar 07-10: 'nu staat er een groen bolletje en lijkt het morgen in huis') ----
     Een maat die Shopify doorverkoopt terwijl de voorraad op is. De pre-orderronde van het portaal zet
     hem zo, met de verwachte datum in het variant-metafield. De levertijd-API kent zo'n maat niet
     (deliveryDate null), en daardoor las alles hem als 'snel': groen bolletje, 'morgen in huis' bij de
     prijs, en 'morgen' in de order. Bron = dezelfde data-pre/data-verw als het paneel 'Levertijd &
     voorraad' (Liquid), elke keer vers gelezen: het thema kan de sectie herbouwen. Staat dat paneel
     uit, dan is er geen bron en blijft alles zoals het was. */
  var PREKLEUR = CFG.cPre || '#7c3aed'; /* paars: los van groen (snel), oranje (later) en grijs (uitverkocht) */
  function preLink() { return document.querySelector('.syk-vrd-link'); }
  function preInfo(sku) {
    var t = preLink(); if (!t || !sku) return null;
    var lijst = []; try { lijst = JSON.parse(t.getAttribute('data-pre') || '[]') || []; } catch (e) { lijst = []; }
    if (lijst.indexOf(String(sku)) < 0) return null;
    var m = {}; try { m = JSON.parse(t.getAttribute('data-verw') || '{}') || {}; } catch (e) { m = {}; }
    /* 'JJJJ-MM-DD' als LOKALE middernacht, net als de stempels van het thema (new Date('2026-10-26')
       is UTC-middernacht en geeft een andere _deliverystamp) */
    var dm = String(m[sku] || '').match(/^([0-9]{4})-([0-9]{2})-([0-9]{2})$/);
    var d = dm ? new Date(+dm[1], +dm[2] - 1, +dm[3]) : (m[sku] ? new Date(m[sku]) : null);
    return { datum: (d && !isNaN(d.getTime())) ? d : null };
  }
  function preWoord(k, dflt) { var t = preLink(); var w = t ? t.getAttribute('data-t-' + k) : ''; return w || dflt; }
  function preKort(d) { try { return d.toLocaleDateString(LOC, { day: 'numeric', month: 'short' }).replace(/\./g, ''); } catch (e) { return ''; } }
  function paintPre(pi) {
    fillDelivProps(pi.datum); /* de order krijgt de verwachte datum mee, niet 'morgen' (leeg als die onbekend is) */
    var deliv = $('.deliv'); if (!deliv) return;
    deliv.classList.remove('is-sold');
    deliv.classList.add('is-later', 'is-pre');
    var pre = preWoord('pre', 'Pre-order'), verw = preWoord('verw', 'verwacht');
    var long = $('.delivery-long', deliv), short = $('.delivery-short', deliv);
    if (long) long.textContent = pre + (pi.datum ? ' \u00b7 ' + verw + ' ' + dateLong(pi.datum) : '');
    if (short) short.textContent = pre + (pi.datum ? ' \u00b7 ' + preKort(pi.datum) : '');
  }
  /* eerstvolgende werkdag (sla za/zo over) — levering op die dag = "snel" (groen) */
  function nextBusinessDay() { var d = sod(new Date()); d.setDate(d.getDate() + 1); while (d.getDay() === 0 || d.getDay() === 6) { d.setDate(d.getDate() + 1); } return d; }
  function isFastest(d) { return sod(d).getTime() <= nextBusinessDay().getTime(); }

  /* ---- quantity stepper ---- */
  (function () {
    var wrap = $('.buyrow'); if (!wrap) return;
    var input = $('.qty', wrap);
    var minus = $('[data-step="-1"]', wrap);
    var plus = $('[data-step="1"]', wrap);
    function qty() { var n = input ? parseInt(input.value, 10) : 1; return (n && n > 0) ? n : 1; }
    function set(n) { if (!input) return; input.value = Math.max(1, n); input.dispatchEvent(new Event('change', { bubbles: true })); }
    if (minus) minus.addEventListener('click', function () { set(qty() - 1); });
    if (plus) plus.addEventListener('click', function () { set(qty() + 1); });
    /* aantal gewijzigd -> leverdatum/badge opnieuw bepalen (refreshBadgeForQty is gehoist) */
    if (input) {
      input.addEventListener('change', function () { refreshBadgeForQty(); });
      var __qt; input.addEventListener('input', function () { clearTimeout(__qt); __qt = setTimeout(function () { refreshBadgeForQty(); }, 350); });
    }
  })();
  function currentQty() {
    /* aantal komt primair uit de NATIVE thema-aantalkiezer (#quantity / [name="quantity"]); valt terug op ons eigen veld */
    var q = document.getElementById('quantity') || document.querySelector('.f8pr-amount input[name="quantity"]') || $('.buyrow .qty') || document.querySelector('input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return (n && n > 0) ? n : 1;
  }
  /* De klant gebruikt de NATIVE thema-aantalkiezer, niet ons veld -> levertijd-badge daarop laten reageren. */
  (function watchThemeQty() {
    var __qtT, __lastQ = 1;
    function ping() { clearTimeout(__qtT); __qtT = setTimeout(function () { refreshBadgeForQty(); paintBarsForQty(); }, 200); }
    document.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') ping(); });
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'quantity') ping(); });
    /* vangnet: +/- stepperknoppen van het thema vuren soms geen change/input -> na elke klik het aantal herlezen */
    document.addEventListener('click', function () { setTimeout(function () { var q = currentQty(); if (q !== __lastQ) { __lastQ = q; refreshBadgeForQty(); paintBarsForQty(); } }, 80); }, true);
  })();

  /* ---- thema-eigen cart-drawer (aside#cart) verversen + openen na een toevoeging ---- */
  function openThemeCart() {
    try { if (window.ajaxCart) { if (typeof ajaxCart.load === 'function') ajaxCart.load(); if (typeof ajaxCart.fetchCartCount === 'function') ajaxCart.fetchCartCount(); } } catch (e) {}
    ['cart:refresh', 'cart:build'].forEach(function (ev) { try { document.dispatchEvent(new CustomEvent(ev, { bubbles: true })); } catch (e) {} });
    if (!document.documentElement.classList.contains('m6pn-open')) {
      var opener = document.querySelector('a.m6pn-cli, [data-panel="cart"]');
      if (opener) { try { opener.click(); } catch (e) {} }
    }
  }
  /* prefers-reduced-motion: smooth-scroll uitzetten voor wie dat systeembreed vraagt (audit #23, JS-kant) */
  var SYK_SMOOTH = 'smooth';
  try { if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) SYK_SMOOTH = 'auto'; } catch (e) {}

  /* ---- ATC-metingen (audit #27): fetch('/cart/add.js') vult GA4/GTM/Klaviyo NIET automatisch -> defensief zelf pushen.
     Bron = de /cart/add.js-RESPONSE (bevat titel/prijs/variant/sku — geen lookups nodig).
     BEWUST NIET: Shopify.analytics.publish('product_added_to_cart') — trekkie instrumenteert cart-AJAX zelf al,
     nogmaals publiceren = dubbeltelling in web pixels. BEWUST NIET: Elevar 'dl_add_to_cart' — dat schema vult
     Elevars eigen listener; een handmatige push met afwijkend formaat verstoort de server-side feed. ---- */
  function sykTrackATC(res) {
    var items = (res && res.items) ? res.items : (res && res.id ? [res] : []);
    if (!items.length) return;
    var gaItems = [], value = 0;
    items.forEach(function (it) {
      var p = (it.price || 0) / 100;
      value += p * (it.quantity || 1);
      gaItems.push({ item_id: String(it.variant_id || it.id || ''), item_name: it.product_title || it.title || '', item_variant: it.variant_title || '', price: p, quantity: it.quantity || 1 });
    });
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null }); /* GTM-conventie: vorige ecommerce-object wissen */
      window.dataLayer.push({ event: 'add_to_cart', ecommerce: { currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR', value: Math.round(value * 100) / 100, items: gaItems } });
    } catch (e) {}
    try {
      var k = window.klaviyo || window._learnq;
      if (k && typeof k.push === 'function') {
        items.forEach(function (it) {
          k.push(['track', 'Added to Cart', { $value: Math.round((it.price || 0) * (it.quantity || 1)) / 100, Name: it.product_title || it.title || '', ProductID: it.product_id || '', VariantID: it.variant_id || it.id || '', SKU: it.sku || '', Quantity: it.quantity || 1, URL: location.href }]);
        });
      }
    } catch (e) {}
  }
  function addToCartAjax(items, done, fail) {
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (res) { try { sykTrackATC(res); } catch (e) {} if (done) done(); })
      .catch(function () { if (fail) fail(); });
  }

  /* ---- hoofd-koopknop: AJAX toevoegen + cart-drawer openen (i.p.v. paginanavigatie) ---- */
  (function () {
    var form = $('.syk-pdp-form'); if (!form) return;
    form.addEventListener('submit', function (e) {
      var v = selectedVar(); if (!v || !v.id) return;
      e.preventDefault();
      if (!v.available) return;
      var btn = $('.cta', form); if (btn) btn.disabled = true;
      addToCartAjax([{ id: v.id, quantity: currentQty() }],
        function () { if (btn) btn.disabled = false; openThemeCart(); },
        function () { if (btn) btn.disabled = false; if (typeof form.submit === 'function') form.submit(); });
    });
  })();

  /* ---- galerij: thumbnails/bolletjes/swipe wisselen; klik + loep openen de lightbox ---- */
  (function () {
    var gmain = $('.gmain'); if (!gmain) return;
    var mainImg = $('.gimg', gmain) || $('img', gmain); if (!mainImg) return;
    var thumbs = $all('.thumbs .th');
    var dots = $all('.gdots b');
    var cnt = $('.gc-n', gmain);
    var imgs = (window.SP_IMAGES && window.SP_IMAGES.length)
      ? window.SP_IMAGES.map(function (o) { return o.full; })
      : thumbs.map(function (t) { return t.getAttribute('data-full'); });
    imgs = imgs.filter(Boolean);
    var n = imgs.length; if (n < 1) return;
    var cur = 0;
    function show(i) {
      if (i < 0) i = n - 1; else if (i >= n) i = 0;
      cur = i;
      if (imgs[i]) mainImg.src = imgs[i];
      thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      if (cnt) cnt.textContent = (i + 1);
      var at = thumbs[i];
      if (at && at.scrollIntoView) { try { at.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} }
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); }); });

    /* lightbox = Fancybox (identiek aan het live thema) */
    function openLb() {
      if (window.Fancybox && typeof window.Fancybox.show === 'function') {
        window.Fancybox.show(imgs.map(function (s) { return { src: s, type: 'image' }; }), { startIndex: cur });
      }
    }
    mainImg.addEventListener('click', openLb);
    var gz = $('.gzoom', gmain);
    if (gz) gz.addEventListener('click', function (e) { e.stopPropagation(); openLb(); });

    /* swipe op de hoofdfoto wisselt het beeld */
    var sx = null;
    gmain.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    gmain.addEventListener('touchend', function (e) {
      if (sx == null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 35) show(cur + (dx < 0 ? 1 : -1));
      sx = null;
    }, { passive: true });
  })();

  /* ---- maat-selectie: radio's + sticky/koopknop bijwerken ---- */
  function selectedVar() {
    var r = $('input[name="id"]:checked'); if (r && byId[String(r.value)]) return byId[String(r.value)];
    var hid = $('.syk-pdp-form [name="id"]'); if (hid && byId[String(hid.value)]) return byId[String(hid.value)];
    return VARS[0] || null;
  }
  /* uitverkochte (gekozen) variant -> native koopknop verbergen + Klaviyo back-in-stock tonen; anders andersom.
     Vangnet: blijft het Klaviyo-anker leeg (niet geladen), toon dan toch weer de (uitverkocht-)koopknop. */
  var SYK_ATC_LBL = { nl: 'In winkelwagen', en: 'Add to cart', de: 'In den Warenkorb', fr: 'Ajouter au panier', es: 'A\u00f1adir al carrito', it: 'Aggiungi al carrello' };
  var SYK_OOS_TEKSTEN = ['niet op voorraad', 'out of stock', 'ausverkauft', '\u00e9puis\u00e9', 'agotado', 'esaurito'];
  function syncBIS(v) {
    /* ALLE ankers pakken (desktop- en mobiel-blok renderen elk een exemplaar) en de uit-stand ook
       als html-klasse zetten: de bijbehorende css met !important wint van elke inline-stijl die
       Klaviyo er later op zet — de klasse is de waarheid, de inline styles zijn compat. */
    var bissen = [].slice.call(document.querySelectorAll('[id="back-in-stock-block"], .syk-bis'));
    var buys = [].slice.call(document.querySelectorAll('.f8pr-buy-button'));
    var sold = !!(v && v.available === false);
    document.documentElement.classList.toggle('syk-bis-uit', !sold);
    buys.forEach(function (f) { f.style.display = sold ? 'none' : ''; });
    /* melding eigenaar: pagina geladen op ?variant=<uitverkocht> (klik op uitverkochte maat herlaadt zo)
       rendert de native koopknop server-side als class-'disabled' met 'Niet op voorraad' — bij terugwissel
       naar een leverbare maat verdween wel de BIS-knop maar bleef de koopknop grijs. Hier her-activeren:
       class weg + label terug (alleen als de tekst exact de uitverkocht-tekst is; sticky-knop met eigen
       markup blijft zo intact), en de 'Niet op voorraad'-fotobadge verbergen. Andersom hoeft niet:
       een uitverkochte maat kiezen is altijd een herlaad. */
    if (!sold) {
      var lbl = SYK_ATC_LBL[String(document.documentElement.lang || 'nl').slice(0, 2).toLowerCase()] || SYK_ATC_LBL.nl;
      [].forEach.call(document.querySelectorAll('button[type="submit"].disabled, button[name="add"].disabled'), function (b) {
        var vanProduct = b.id === 'AddToCart' || b.closest('.f8pr-buy-button') || String(b.getAttribute('form') || '').indexOf('product-form') > -1;
        if (!vanProduct) return;
        b.classList.remove('disabled', 'visible', 'overlay-quinary');
        b.classList.add('overlay-tertiary'); /* de groene koop-stijl: leverbaar rendert het thema als overlay-tertiary (hoofdknop en sticky identiek, serververgelijking beide staten) */
        b.disabled = false;
        if (SYK_OOS_TEKSTEN.indexOf(b.textContent.trim().toLowerCase()) > -1) b.textContent = lbl;
      });
      [].forEach.call(document.querySelectorAll('.s1lb.label span, .s1lb span'), function (sp) {
        if (sp.children.length === 0 && SYK_OOS_TEKSTEN.indexOf(sp.textContent.trim().toLowerCase()) > -1) sp.style.display = 'none';
      });
    }
    bissen.forEach(function (bis) {
      /* verbergen met inline-!important: dat is het enige dat wint van een eventuele
         inline-!important-show van Klaviyo (stylesheet-!important verliest daarvan — live gemeten);
         en omdat observer + failsafe-interval ons altijd het laatste woord geven, blijft uit uit */
      if (sold) { bis.style.removeProperty('display'); }
      else { bis.style.setProperty('display', 'none', 'important'); }
    });
    if (sold && bissen.length) {
      setTimeout(function () {
        var leeg = !bissen.some(function (b) { return b.querySelector('*'); });
        if (leeg) { buys.forEach(function (f) { f.style.display = ''; }); bissen.forEach(function (b) { b.style.display = 'none'; }); }
      }, 2500);
    }
  }
  /* ---- PRIJS volgt de gekozen variant (melding eigenaar 29-08: 'Schotse Man' kost in S/M/L 59,95
     en in XL/XXL/XXXL 69,95, maar de PDP bleef 59,95 tonen — de klant zag dus een andere prijs dan
     hij afrekende). Oorzaak: syncSelection werkte alles bij (chips, koopknop, verborgen id's, BIS,
     URL, levertijd) BEHALVE de prijs, en het thema kan het niet overnemen omdat wij bewust geen
     change-event naar zijn handler sturen (custom-async crasht daarop, zie de notitie hierboven).
     SP_VARS draagt sinds 29-08 price/cmp in CENTEN mee; ontbreken ze (oude graft nog niet geplakt),
     dan doet deze functie niets en blijft de server-render staan = nul risico.
     LET OP bij wijzigen: $ en $all in dit bestand plakken ZELF al '.syk-pdp ' voor de selector
     (regel 48-49). Schrijf dus $('.priceline'), NIET $('.syk-pdp .priceline') — dat werd
     '.syk-pdp .syk-pdp .priceline' en matchte niets (die fout kostte 31-08 een deploy-ronde). ---- */
  function sykGeld(cent) {
    var d = (Math.round(cent) / 100).toFixed(2).split('.');
    return '\u20ac' + d[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + d[1]; /* €1.299,95 */
  }
  function sykPrijsSync(v) {
    if (!v || v.price === null || v.price === undefined) return;
    var opSale = v.cmp !== null && v.cmp !== undefined && v.cmp > v.price;
    var lijn = $('.priceline');
    if (lijn) {
      var pr = $('.price', lijn);
      if (pr) { pr.textContent = sykGeld(v.price); pr.classList.toggle('on-sale', opSale); }
      var was = $('.price-was', lijn), bdg = $('.price-badge', lijn);
      if (opSale) {
        /* van-prijs en kortingsbadge bestaan alleen in de server-render als DIE variant in de
           aanbieding stond; bij een wissel naar een afgeprijsde variant maken we ze alsnog aan.
           Zonder inline stijl: .price-was/.price-badge zijn volledig via syk-pdp.css opgemaakt. */
        if (!was) { was = document.createElement('span'); was.className = 'price-was'; if (pr) pr.insertAdjacentElement('afterend', was); else lijn.appendChild(was); }
        was.textContent = sykGeld(v.cmp); was.style.display = '';
        if (!bdg) { bdg = document.createElement('span'); bdg.className = 'price-badge'; was.insertAdjacentElement('afterend', bdg); }
        bdg.textContent = '-' + Math.round((v.cmp - v.price) * 100 / v.cmp) + '%'; bdg.style.display = '';
      } else {
        if (was) was.style.display = 'none';
        if (bdg) bdg.style.display = 'none';
      }
    }
    $all('.stb-price').forEach(function (el) { el.textContent = sykGeld(v.price); });
  }
  function syncSelection() {
    var v = selectedVar(); if (!v) return;
    sykPrijsSync(v);
    $all('.sz').forEach(function (b) { b.classList.toggle('sel', String(b.getAttribute('data-id')) === String(v.id)); });
    var stbSize = $('.stb-size b'); if (stbSize && v.title) stbSize.textContent = v.title;
    $all('.cta').forEach(function (c) { c.disabled = !v.available; });
    $all('.sp-buy-id').forEach(function (h) { h.value = v.id; }); /* verborgen id in losse koopknop-blok synchroon houden */
    /* 02-07: NATIVE koopformulier MEE-syncen. Op templates waar alleen ons syk_sizes-blok is bedraad
       (geen native variant_selection) valt het thema terug op een verborgen fallback-id-input met de
       SERVERVARIANT -> de native AddToCart (en dus ook de sticky bar) voegde altijd de beginmaat toe.
       Alleen waardes zetten, GEEN events dispatchen (custom-async crasht op change van onze radio's). */
    [].forEach.call(document.querySelectorAll('input.f8pr-fallback-id-input, input[type="hidden"][name="id"][form], select[name="id"][form], select[name="id"][data-template]'), function (el) {
      if (el.closest && el.closest('.syk-pdp')) return;
      try { el.value = String(v.id); } catch (e) {}
    });
    [].forEach.call(document.querySelectorAll('input[type="radio"][name="id"][form]'), function (el) {
      if (el.closest && el.closest('.syk-pdp')) return;
      el.checked = String(el.value) === String(v.id);
    });
    syncBIS(v); /* koopknop <-> back-in-stock */
    /* kwam de bezoeker binnen op ?variant=<uitverkocht> (klik op een uitverkochte maat herlaadt zo),
       laat de URL dan meebewegen met de nieuwe keuze: Klaviyo (en alles wat de URL leest) kijkt
       anders blijvend naar de oude uitverkochte variant */
    try {
      if (new URLSearchParams(location.search).has('variant') && history.replaceState) {
        var u3 = new URL(location.href);
        u3.searchParams.set('variant', String(v.id));
        history.replaceState(null, '', u3.toString());
      }
    } catch (e) {}
    refreshBadgeForQty(); /* levertijd-badge volgt de gekozen maat ÉN het gekozen aantal */
  }
  /* galerij naar de gekozen variant (wens eigenaar 25-07: 'kies je een kleur, toon dan direct de
     gekoppelde foto'). De .sz-knop draagt data-media = de POSITIE van variant.featured_media (1-based,
     alleen aanwezig als de variant een eigen media heeft). De thema-Swiper toont de media in
     positie-volgorde, dus slide-index = positie - 1 (live geverifieerd: Roze pos 5 -> juiste foto).
     ALLEEN bij een echte gebruikersactie (klik/change), niet bij het laden -> geen sprong bij openen. */
  function sykGalNaarVariant(btn) {
    try {
      var el = btn || document.querySelector('.syk-pdp .sz.sel[data-media]');
      if (!el || !el.getAttribute('data-media')) return;
      var pos = parseInt(el.getAttribute('data-media'), 10);
      if (!pos || pos < 1) return;
      var ul = document.querySelector('.l4pr[data-media-size]');
      var outer = ul && ul.querySelector('.swiper-outer');
      var sw = (outer && outer.swiper) || (ul && ul.swiper);
      if (!sw) return;
      var idx = pos - 1;
      if (sw.params && sw.params.loop && typeof sw.slideToLoop === 'function') sw.slideToLoop(idx);
      else if (typeof sw.slideTo === 'function') sw.slideTo(idx);
    } catch (e) {}
  }
  $all('.sz').forEach(function (b) {
    b.addEventListener('click', function () {
      var id = b.getAttribute('data-id'); if (!id) return;
      if (b.classList.contains('out')) {
        /* uitverkochte maat: wél selecteerbaar -> herlaad met deze variant zodat Klaviyo back-in-stock precies deze variant oppakt en de koopknop wordt vervangen */
        try { var u = new URL(window.location.href); u.searchParams.set('variant', id); window.location.href = u.toString(); }
        catch (e) { window.location.search = '?variant=' + id; }
        return;
      }
      var r = $('input[name="id"][value="' + id + '"]');
      if (r) { r.checked = true; } /* GEEN change-dispatch: dat triggert de thema-handler (custom-async.js) die op onze radio's crasht op undefined data-template (startsWith) */
      syncSelection();
      sykGalNaarVariant(b);
    });
  });
  document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') { syncSelection(); sykGalNaarVariant(); } });
  syncSelection();
  /* bfcache: terug-navigatie herstelt de bevroren DOM (incl. oude BIS-staat) zonder scripts opnieuw
     te draaien — bij pageshow de hele selectie-staat opnieuw afdwingen */
  window.addEventListener('pageshow', function () { try { syncSelection(); } catch (e) {} });
  /* failsafe: eerste ~16s elke 800ms de BIS-staat herbevestigen — vangt elk Klaviyo-timingpad
     dat observer/events zou missen; zelfde-waarde-writes zijn visueel gratis */
  var bisTik = 0;
  var bisKlok = setInterval(function () {
    try { syncBIS(selectedVar()); } catch (e) {}
    if (++bisTik >= 20) clearInterval(bisKlok);
  }, 800);
  /* Klaviyo laadt async NA onze init en zet het back-in-stock-anker zelf zichtbaar zodra hij de knop
     injecteert — ook als de gekozen maat gewoon leverbaar is (zijn variantdetectie kent onze radio's
     niet; hij ziet alleen dat ER een uitverkochte maat is). Elke mutatie in/op het anker -> onze
     staat opnieuw afdwingen; schrijven van dezelfde display-waarde geeft geen nieuwe mutatie, dus
     dit convergeert zonder lus. */
  (function () {
    var bis = document.getElementById('back-in-stock-block');
    if (!bis || !window.MutationObserver) return;
    var bezig = false;
    new MutationObserver(function () {
      if (bezig) return;
      bezig = true;
      try { syncBIS(selectedVar()); } catch (e) {}
      setTimeout(function () { bezig = false; }, 50);
    }).observe(bis, { childList: true, attributes: true, attributeFilter: ['style', 'class'] });
  })();

  /* sticky mobiele koopbalk (audit #2): koopt via de NATIVE koopknop (#AddToCart) zodat alle thema-listeners
     en pixels het bestaande pad volgen; fallback = ons eigen V2-form (ajax, incl. sykTrackATC).
     Zichtbaar zodra de koopknop boven de viewport uit beeld is gescrold; verborgen bij uitverkochte variant. */
  (function () {
    var bar = $('[data-sticky-bar]');
    var stb = $('[data-sticky-add]');
    if (!stb) return;
    var nativeBtn = document.getElementById('AddToCart') || document.querySelector('.f8pr-buy-button [type="submit"], .f8pr-buy-button button[name="add"], button[name="add"]');
    var form = $('.syk-pdp-form');
    if (!nativeBtn && !form) return;
    stb.addEventListener('click', function () {
      var v = selectedVar(); if (v && v.available === false) return;
      if (nativeBtn) { try { nativeBtn.click(); return; } catch (e) {} }
      if (form) { if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit(); }
    });
    if (!bar) return; /* oude markup (sectie-variant zonder data-sticky-bar): alleen de click-hook */
    var lastShow = false;
    function sold() { var v = selectedVar(); return !!(v && v.available === false); }
    function setVis(show) { lastShow = show; if (show && !sold()) bar.removeAttribute('hidden'); else bar.setAttribute('hidden', ''); }
    var watch = nativeBtn || (form ? form.querySelector('.cta') : null);
    if (watch && 'IntersectionObserver' in window) {
      /* alleen tonen als de koopknop BOVEN de viewport verdween (echt voorbij gescrold, niet 'nog onder de vouw') */
      var io = new IntersectionObserver(function (en) { setVis(!en[0].isIntersecting && en[0].boundingClientRect.top < 0); }, { threshold: 0 });
      io.observe(watch);
    } else { setVis(true); }
    /* maatwissel kan naar uitverkocht schakelen -> zichtbaarheid herzien (radio-change én .sz-klik, die geen change dispatcht) */
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') setVis(lastShow); });
    document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('.sz')) setTimeout(function () { setVis(lastShow); }, 0); });
  })();

  /* Drawer-/cart-upsell-verrijking (levertijd + "x"-opruiming) is verhuisd naar het SITE-BREDE
     snippets/syk-upsell-delivery.liquid (gerenderd via side-cart-container.liquid) — de drawer opent
     immers ook op /cart en andere pagina's waar dit bestand niet laadt. Hier bewust niets meer. */

  /* ---- LEVERTIJD: 1 bulk-call -> badge naast prijs + per-maat kleurbalk + USP ---- */
  function fmtBadge(d) {
    if (d && !isNaN(d.getTime())) {
      if (diffDays(d) <= 0) {
        if (vandaagNogMogelijk()) return { later: false, long: vandaagTekst(), short: VD.kort };
        d = nextBusinessDay(); /* besteltijd voorbij, econcepts nog niet bijgewerkt */
      }
      if (isFastest(d)) {
        var n = diffDays(d);
        var word = (n <= 0) ? (I18.wToday || 'vandaag') : (n === 1 ? (I18.wTomorrow || 'morgen') : dayName(d));
        var sw = (n <= 0) ? (I18.sToday || 'Vandaag') : (n === 1 ? (I18.sTomorrow || 'Morgen') : dayName(d));
        return { later: false, long: (CFG.fast || 'Voor 23:59 besteld =').replace(/\s*$/, ' ') + word + DSUF, short: sw + DSUF };
      }
      return { later: true, long: cap(dateLong(d)), short: cap(dateShort(d)) };
    }
    return { later: false, long: (CFG.fast || 'Voor 23:59 besteld =').replace(/\s*$/, ' ') + (I18.wTomorrow || 'morgen') + DSUF, short: (I18.sTomorrow || 'Morgen') + DSUF };
  }
  function paintSold() {
    fillDelivProps(null); /* uitverkocht -> geen leverdatum in de order-props */
    var deliv = $('.deliv'); if (!deliv) return;
    deliv.classList.remove('is-later', 'is-pre'); deliv.classList.add('is-sold');
    var long = $('.delivery-long', deliv), short = $('.delivery-short', deliv);
    if (long) long.textContent = (I18.soldout || 'Uitverkocht');
    if (short) short.textContent = (I18.soldout || 'Uitverkocht');
  }
  function paintBadge(d) {
    fillDelivProps(d); /* order-props synchroon met de getoonde leverdatum (vóór de .deliv-guard: ook op templates zonder badge-element) */
    var b = fmtBadge(d);
    var deliv = $('.deliv'); if (!deliv) return;
    deliv.classList.remove('is-sold', 'is-pre');
    deliv.classList.toggle('is-later', b.later);
    var long = $('.delivery-long', deliv), short = $('.delivery-short', deliv);
    if (long) long.textContent = b.later ? (CFG.later || 'Geleverd op').replace(/\s*$/, ' ') + b.long : b.long;
    if (short) short.textContent = b.short;
  }
  function paintSelectedBadge() {
    var v = selectedVar();
    if (!v || v.available === false) { paintSold(); return; } /* uitverkocht -> 'Uitverkocht' i.p.v. levertijd */
    var pi = preInfo(v.sku); if (pi) { paintPre(pi); return; } /* pre-order: geen API-datum, wel de verwachte */
    if (!DELIV) return;
    var rec = DELIV[v.sku];
    paintBadge(rec && rec.deliveryDate ? new Date(rec.deliveryDate) : null);
  }
  /* leverdatum/voorraad-badge mee laten lopen met het gekozen AANTAL via de STAFFEL-endpoint:
     1 call per maat (gecachet), daarna client-side de juiste voorraad-tier kiezen -> instant.
     Verandert pas zichtbaar als het aantal een tier-grens overschrijdt (bv. >178 stuks). */
  var STAFFEL = {};
  var __qtySeq = 0;
  function tierDate(tiers, qty) {
    if (!tiers || !tiers.length) return undefined;        /* onbekend -> badge ongemoeid laten */
    for (var i = 0; i < tiers.length; i++) {
      if (qty <= tiers[i].available) return tiers[i].deliveryDate ? new Date(tiers[i].deliveryDate) : null;
    }
    return null;                                          /* boven de hoogste tier = niet in dit aantal leverbaar */
  }
  /* Uit WELKE trap komt dit aantal? Trap 0 is eigen voorraad, vanaf trap 1 moet het bij de
     leverancier vandaan — en dat bepaalt welke cutoff geldt. Boven de hoogste trap valt het
     sowieso op de leverancier terug, dus dan de laatste trap. */
  function tierIndex(tiers, qty) {
    if (!tiers || !tiers.length) return -1;
    for (var i = 0; i < tiers.length; i++) { if (qty <= tiers[i].available) return i; }
    return -2; /* boven de hoogste trap: welke schakel dit wordt weten we niet -> geen deadline claimen */
  }
  function refreshBadgeForQty() {
    var v = selectedVar();
    if (!v || v.available === false) { paintSold(); return; } /* uitverkocht: 'Uitverkocht' (geen levertijd-data nodig) */
    var pi = preInfo(v.sku); if (pi) { paintPre(pi); return; } /* pre-order: elk aantal dezelfde verwachte datum */
    if (!DELIV) return;                                   /* nog geen levertijd-data geladen */
    var q = currentQty();
    if (q <= 1) { paintSelectedBadge(); return; }
    if (STAFFEL[v.sku]) { var dc = tierDate(STAFFEL[v.sku], q); if (dc !== undefined) { paintBadge(dc); } return; }
    var seq = ++__qtySeq;
    fetch(STAFFEL_URL, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ products: [{ sku: v.sku, quantity: 1 }] }) })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        STAFFEL[v.sku] = (data && data.length) ? data : [];
        if (seq !== __qtySeq) return;                     /* alleen de laatste keuze telt */
        var d2 = tierDate(STAFFEL[v.sku], q);
        if (d2 !== undefined) paintBadge(d2);
      })
      .catch(function () { /* API onbereikbaar: laat de bestaande badge staan */ });
  }
  /* chips + legenda mee laten lopen met het AANTAL (melding eigenaar 27-07: badge zei 'Donderdag'
     bij aantal 2, maar het bolletje op de maat bleef groen 'morgen' — de load-fetch rekent met
     aantal 1). Zelfde bron als de badge: de staffel-tiers per maat (1 call per sku, gecachet in
     STAFFEL, daarna instant) -> badge, bolletjes en legenda zijn per definitie consistent.
     paintBars herbouwt daarbij ook de dynamische legenda. Aantal terug naar 1 = baseline (DELIV,
     de bulk-call) terugzetten. Tier onbekend (geen data) of aantal boven de hoogste tier: die
     maat behoudt zijn baseline-kleur (niet gokken). Seq-guard: alleen de laatste keuze telt. */
  var __barsSeq = 0;
  function paintBarsForQty() {
    if (!DELIV) return;
    var q = currentQty();
    if (q <= 1) { paintBars(DELIV); return; }
    var seq = ++__barsSeq;
    var doel = VARS.filter(function (v) { return v.available && v.sku; });
    Promise.all(doel.map(function (v) {
      if (STAFFEL[v.sku]) return Promise.resolve();
      return fetch(STAFFEL_URL, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ products: [{ sku: v.sku, quantity: 1 }] }) })
        .then(function (r) { return r.json(); })
        .then(function (data) { STAFFEL[v.sku] = (data && data.length) ? data : []; })
        .catch(function () { /* deze maat valt terug op baseline */ });
    })).then(function () {
      if (seq !== __barsSeq) return;
      var map = {};
      Object.keys(DELIV).forEach(function (k) { map[k] = DELIV[k]; });
      doel.forEach(function (v) {
        var dt = tierDate(STAFFEL[v.sku], q);
        if (dt) map[v.sku] = { deliveryDate: dt };
      });
      paintBars(map);
    });
  }
  var SIZEDELIV = null;
  var lookSlowest = null; /* traagste leverdatum van de accessoires in de set (alles gaat in 1 zending) */
  function labelCompMaat() {
    /* maat-select in de comp-koop-rij: levertijd per maat in de optie-tekst ("L · morgen in huis").
       Wens eigenaar 10-07: toon de leverdatum van de HELE set = de traagste van (hoofdproduct-in-deze-maat,
       alle accessoires), want alles wordt in één keer verstuurd. Idempotent + niet herschrijven terwijl het
       dropdown focus heeft (elke maatwissel muteert de pagina -> observer -> zou het menu laten flikkeren). */
    if (!SIZEDELIV) return;
    $all('.syk-comp-maat').forEach(function (sel) {
      if (document.activeElement === sel) return;
      [].forEach.call(sel.options, function (o) {
        var v = byId[String(o.value)]; if (!v) return;
        var basis = o.getAttribute('data-maat');
        if (!basis) { basis = (o.textContent || '').split(' · ')[0].trim(); o.setAttribute('data-maat', basis); }
        var rec = SIZEDELIV[v.sku];
        var d = rec && rec.deliveryDate ? new Date(rec.deliveryDate) : null;
        var setD = (d && !isNaN(d.getTime())) ? d : null;
        if (lookSlowest && !isNaN(lookSlowest.getTime()) && (!setD || lookSlowest > setD)) setD = lookSlowest; /* traagste wint */
        var txt = basis + ' · ' + (setD ? inHuis(setD) : (I18.tomorrow || 'Morgen in huis')).toLowerCase();
        if (o.textContent !== txt) o.textContent = txt;
      });
    });
  }
  function paintBars(products) {
    SIZEDELIV = products;
    labelCompMaat();
    /* dynamische legenda (wens eigenaar 27-07, opt-in via setting vdt_legend_dynamic -> data-dyn op
       .vdt-legend): groen = echte snelste datum ('Vandaag/Morgen in huis'), oranje = vroegste latere
       datum als dagnaam voluit binnen 5 dagen ('Donderdag', via legDag), grijs = 'Uitverkocht'.
       UX/CRO-ronde 27-07: statussen die op GEEN enkele chip voorkomen worden verborgen (signaal >
       ruis; 'Uitverkocht' tonen zonder uitverkochte maat is ruis) — de tekst naast de dot is
       bovendien het redmiddel voor rood-groen-kleurenblinden (groen/oranje luminantie 1.03:1).
       Zonder bema-antwoord (fetch faalt) blijft de statische legenda volledig staan. */
    var lgFastD = null, lgLaterD = null, lgFast = false, lgLater = false, lgSold = false, lgPre = false, lgPreD = null;
    $all('.sz').forEach(function (sz) {
      var v = byId[String(sz.getAttribute('data-id'))]; if (!v) return;
      var bar = $('.bar', sz);
      var st = 'sold', d = null;
      if (v.available) {
        var pi = preInfo(v.sku);
        if (pi) { st = 'pre'; d = pi.datum; } /* pre-order: nooit groen, de API kent hem niet */
        else {
          var rec = products[v.sku]; d = rec && rec.deliveryDate ? new Date(rec.deliveryDate) : null;
          st = (d && !isNaN(d.getTime()) && isFastest(d) == false) ? 'later' : 'fast';
        }
      }
      if (st === 'fast') { lgFast = true; if (d && !isNaN(d.getTime()) && (!lgFastD || d < lgFastD)) lgFastD = d; }
      else if (st === 'later') { lgLater = true; if (!lgLaterD || d < lgLaterD) lgLaterD = d; }
      else if (st === 'pre') { lgPre = true; if (d && (!lgPreD || d < lgPreD)) lgPreD = d; }
      else { lgSold = true; }
      /* pre-order eigen kleur, paars (eigenaar 07-10: 'oranje lijkt te veel op zaterdag') */
      var col = st === 'fast' ? (CFG.cFast || '#1f9d57') : (st === 'later' ? (CFG.cLater || '#d9650a') : (st === 'pre' ? PREKLEUR : (CFG.cSold || '#9aa3ab')));
      sz.classList.toggle('is-pre', st === 'pre');
      if (bar) { bar.style.background = col; bar.style.setProperty('--syk-pre', col); }
      if (CFG.sizeEtaOn) {
        var eta = $('.sz-eta', sz);
        if (!eta) { eta = document.createElement('span'); eta.className = 'sz-eta'; sz.appendChild(eta); }
        eta.textContent = (st === 'sold') ? (I18.soldout || 'Uitverkocht') : (st === 'pre' ? preWoord('pre', 'Pre-order') : ((d && !isNaN(d.getTime())) ? etaShort(d) : ''));
      }
    });
    /* pre-order in de legenda: een eigen regel met een hol bolletje, ook bij een statische legenda.
       Als vierde kind, dus na de drie vaste (de dynamische legenda hieronder telt op die volgorde). */
    $all('.vdt-legend').forEach(function (lg) {
      var sp = lg.querySelector('.vdt-leg-pre');
      if (!lgPre) { if (sp) sp.style.display = 'none'; return; }
      if (!sp) {
        sp = document.createElement('span'); sp.className = 'vdt-leg-pre';
        var dot = document.createElement('i'); dot.className = 'dot dot--pre';
        dot.style.setProperty('--syk-pre', PREKLEUR);
        sp.appendChild(dot); sp.appendChild(document.createTextNode(''));
        lg.insertBefore(sp, lg.querySelector('.syk-vrd-link'));
      }
      sp.style.display = '';
      var tekst = ' ' + preWoord('pre', 'Pre-order') + (lgPreD ? ' (' + preWoord('verw', 'verwacht') + ' ' + preKort(lgPreD) + ')' : '');
      if (sp.lastChild.nodeValue !== tekst) sp.lastChild.nodeValue = tekst;
    });
    $all('.vdt-legend[data-dyn]').forEach(function (lg) {
      var sp = lg.children; if (sp.length < 3) return;
      var zet = function (span, txt) {
        if (!span || !txt) return;
        var t = span.lastChild;
        if (t && t.nodeType === 3) { if (t.nodeValue !== ' ' + txt) t.nodeValue = ' ' + txt; }
        else span.appendChild(document.createTextNode(' ' + txt));
      };
      sp[0].style.display = lgFast ? '' : 'none';
      if (lgFast) zet(sp[0], lgFastD ? inHuis(lgFastD) : (I18.tomorrow || 'Morgen in huis'));
      sp[1].style.display = lgLater ? '' : 'none';
      if (lgLater) zet(sp[1], legDag(lgLaterD));
      sp[2].style.display = lgSold ? '' : 'none';
    });
  }
  function pickFastest(products) {
    var best = null, bestDate = null;
    VARS.forEach(function (v) {
      if (!v.available) return;
      var rec = products[v.sku]; if (!rec || !rec.deliveryDate) return;
      var d = new Date(rec.deliveryDate); if (isNaN(d.getTime())) return;
      if (!bestDate || d < bestDate) { bestDate = d; best = v; }
    });
    return { v: best, d: bestDate };
  }
  /* expliciete variantkeuze herkennen (melding eigenaar 21-07): een ?variant= in de URL (BIS-herlaad,
     kleur-swatch, zoek-ATC) of een klik op een maatknop vóór het bulk-antwoord = bewuste keuze die de
     auto-select NOOIT mag overrulen. Alles daarbuiten is slechts de server-default. */
  var sykKoos = /[?&]variant=/.test(location.search);
  document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('.sz')) sykKoos = true; }, true);
  if (VARS.length) {
    fetch(BULK, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ products: VARS.map(function (v) { return { sku: v.sku, quantity: 1, available: v.available }; }) }) })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.products) ? data.products : {};
        DELIV = products;
        paintBars(products);
        var sel = selectedVar();
        var fast = pickFastest(products);
        /* auto-select snelste leverbare variant (1x) — óók als de server-default een TRAGERE
           leverbare variant is (melding eigenaar 21-07: Zwart 23-07 stond aan terwijl Bruin 22-07
           kon). Alleen zonder expliciete keuze (sykKoos); bij gelijke of onbekende snelheidswinst
           blijft de default staan. */
        if (CFG.autoOn && fast.v && !sykKoos) {
          var wissel = !sel || !sel.available;
          if (!wissel && sel.id !== fast.v.id) {
            var selRec = products[sel.sku];
            var selD = selRec && selRec.deliveryDate ? new Date(selRec.deliveryDate) : null;
            wissel = !selD || isNaN(selD.getTime()) || fast.d < selD;
          }
          if (wissel && (!sel || String(sel.id) !== String(fast.v.id))) {
            var r = $('input[name="id"][value="' + fast.v.id + '"]');
            if (r && !r.checked) { r.checked = true; } /* idem: geen change-dispatch naar de crashende thema-handler */
            syncSelection();
          }
        }
        /* badge volgt de gekozen maat; valt anders terug op de snelste leverbare */
        var cur = selectedVar();
        if (cur && cur.available && preInfo(cur.sku)) {
          paintSelectedBadge(); /* pre-order gekozen: nooit de datum van een andere maat tonen */
        } else if (cur && cur.available && products[cur.sku] && products[cur.sku].deliveryDate) {
          paintSelectedBadge();
        } else if (fast.v && products[fast.v.sku] && products[fast.v.sku].deliveryDate) {
          paintBadge(new Date(products[fast.v.sku].deliveryDate));
        } else if (cur && cur.available === false) {
          paintSold();
        } else {
          paintBadge(null);
        }
      })
      .catch(function () { /* TODO levertijd-API onbereikbaar: server-gerenderde badge blijft staan */ });
  }

  /* ---- tabs (.syk-pdp.info-blocks is al server-side gezet -> dan geen tab-wissel nodig) ---- */
  (function () {
    /* tabs altijd actief (info-blocks-modus vervallen) */
    var panels = $all('.tabpanel'), btns = $all('.tabbtn');
    function showTab(id) {
      if (!$('#' + id)) return;
      panels.forEach(function (p) { p.classList.toggle('on', p.id === id); });
      btns.forEach(function (t) {
        var on = t.getAttribute('data-tab') === id;
        t.classList.toggle('on', on);
        /* ARIA-tabs (audit #8): alleen syncen als de Liquid de role al zet — progressive enhancement */
        if (t.getAttribute('role') === 'tab') t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      /* lazy-load-widgets (bv. Judge.me) in het nu-zichtbare paneel laten initialiseren */
      try { window.dispatchEvent(new Event('resize')); window.dispatchEvent(new Event('scroll')); } catch (e) {}
    }
    btns.forEach(function (t) { t.addEventListener('click', function () { showTab(t.getAttribute('data-tab')); }); });
    $all('[data-tab-link]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('data-tab-link'); var el = $('#' + id);
        if (el) { e.preventDefault(); showTab(id); try { el.scrollIntoView({ behavior: SYK_SMOOTH, block: 'start' }); } catch (x) {} }
      });
    });
    /* thema-ankerlinks naar de juiste tab: sterren (#judgeme_product_reviews) -> Beoordelingen,
       'lees meer' (#section-info) -> eerste tab (Beschrijving). De thema-id's bestaan niet in onze tabs.
       Zoek de tab-knop GLOBAAL (niet via .sp-sec — die class is niet uniek, vandaar dat 'ie eerder op Beschrijving bleef). */
    function syk_jumpHash(hash) {
      var btn = null;
      if (hash === '#judgeme_product_reviews') { btn = $('.tabbtn[data-tab="sp-reviews"]'); }
      else if (hash === '#section-info') { btn = $('.tabnav .tabbtn'); }
      else { return false; }
      if (!btn) return false;
      var id = btn.getAttribute('data-tab');
      showTab(id);
      var panel = $('#' + id);
      var wrap = (panel && panel.closest('.sp-sec')) || btn.closest('.sp-sec') || panel || btn;
      if (wrap) { try { wrap.scrollIntoView({ behavior: SYK_SMOOTH, block: 'start' }); } catch (x) {} }
      return true;
    }
    document.addEventListener('click', function (e) {
      var a = (e.target && e.target.closest) ? e.target.closest('a[href="#section-info"],a[href="#judgeme_product_reviews"]') : null;
      if (a && syk_jumpHash(a.getAttribute('href'))) e.preventDefault();
    });
    if (location.hash === '#section-info' || location.hash === '#judgeme_product_reviews') {
      setTimeout(function () { syk_jumpHash(location.hash); }, 350);
    }
  })();

  /* ---- "Maak je look compleet": aantal-stepper vóór de complete-look-knop; los item toevoegen; herhaald toevoegen (andere maat) mogelijk ---- */
  /* drawer vers renderen (sectie-API) + thema-inits nadraaien; het thema's eigen updateCartPanel zit in
     een closure en zijn handlers zijn per render gebonden -> na ONZE render nemen de delegaties hieronder
     verwijderen/aantal over (AJAX, geen /cart-navigatie). e.defaultPrevented-guard voorkomt dubbel werk
     wanneer de thema-render met eigen handlers actief is. */
  function sykVerversDrawer(openPanel) {
    fetch('/?section_id=side-cart', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var box = document.getElementById('cart'); if (!box) { if (openPanel) openThemeCart(); return; }
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var vers = tmp.querySelector('#shopify-section-side-cart');
        if (vers) {
          /* het thema rendert de sluitknop (a.m6pn-close, met zijn handlers) als direct kind van #cart,
             BUITEN de sectie-render — origineel element bewaren en terugzetten, anders is het kruisje weg */
          var sluit = box.querySelector(':scope > a.m6pn-close');
          box.innerHTML = vers.innerHTML;
          if (sluit) box.appendChild(sluit);
          try {
            if (typeof amountRun === 'function') {
              var els = box.querySelectorAll('.input-amount:not(.semantic-input-initialized)');
              [].forEach.call(els, amountRun);
              if (typeof amountClick === 'function') amountClick(els);
            }
          } catch (e) {}
          /* levertijden per cartregel: het thema vult .custom-deliverytime pas op zijn window-event
             (fetchDeliveryTimesHandler in custom-async.js leest data-deliveryinfo op de li's) —
             na onze innerHTML-replace moeten wij dat event zelf vuren, anders blijven de regels leeg */
          try { window.dispatchEvent(new CustomEvent('fetchDeliverytimes')); } catch (e) {}
        }
        if (openPanel) openThemeCart();
      })
      .catch(function () { if (openPanel) openThemeCart(); });
  }
  function sykCartChange(key, qty) {
    var x = new XMLHttpRequest();
    x.open('POST', '/cart/change.js', true);
    x.setRequestHeader('Content-Type', 'application/json');
    x.setRequestHeader('Accept', 'application/json');
    x.onload = function () { sykVerversDrawer(false); };
    x.send(JSON.stringify({ id: key, quantity: qty }));
  }
  document.addEventListener('click', function (e) {
    var rm = e.target && e.target.closest ? e.target.closest('#cart a.remove-from-cart-link') : null;
    if (!rm || e.defaultPrevented) return;
    e.preventDefault();
    var key = rm.getAttribute('data-key');
    if (!key) { try { key = new URL(rm.href, location.origin).searchParams.get('id'); } catch (er) {} }
    if (key) sykCartChange(key, 0);
  });
  var sykQtyT = null;
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || inp.name !== 'updates[]' || !inp.closest || !inp.closest('#cart') || e.defaultPrevented) return;
    var key = inp.getAttribute('data-key'); var q = parseInt(inp.value, 10);
    if (!key || isNaN(q) || q < 0) return;
    clearTimeout(sykQtyT); sykQtyT = setTimeout(function () { sykCartChange(key, q); }, 250);
  });
  document.addEventListener('click', function (e) {
    var pm = e.target && e.target.closest ? e.target.closest('#cart .input-amount .incr, #cart .input-amount .decr') : null;
    if (!pm || e.defaultPrevented) return;
    var wrap = pm.closest('.input-amount');
    var inp = wrap ? wrap.querySelector('input[name="updates[]"]') : null;
    if (!inp) return;
    var key = inp.getAttribute('data-key'); if (!key) return;
    clearTimeout(sykQtyT);
    sykQtyT = setTimeout(function () { var q = parseInt(inp.value, 10); if (!isNaN(q) && q >= 0) sykCartChange(key, q); }, 350);
  });

  function bindLook(lookRoot) {
    if (lookRoot.getAttribute('data-syk-look-bound')) return;
    var box = lookRoot.querySelector('.items'); if (!box) return;
    lookRoot.setAttribute('data-syk-look-bound', '1');
    var items = $all('.item', box);
    var totalEl = lookRoot.querySelector('[id^="sp-looktotal"]'), oldEl = lookRoot.querySelector('[id^="sp-lookold"]');
    var dattr = (lookRoot.getAttribute('data-disc') || '').replace(/[^0-9.]/g, '');
    var disc = dattr ? parseFloat(dattr) : parseFloat(CFG.lookDiscount);
    if (isNaN(disc) || disc < 0 || disc >= 100) disc = 0;
    /* native .input-amount-stepper VERVANGT het <input> bij init (innerHTML-rewrap) -> NIET cachen, elke keer vers uitlezen */
    function lookQty() { var qi = lookRoot.querySelector('.look-amount input'); var n = qi ? parseInt(qi.value, 10) : 1; return (n && n > 0) ? n : 1; }
    function recalc() {
      /* korting geldt ALLEEN op de accessoires, niet op het hoofdproduct — moet gelijk lopen met de server-side discount function (discount-function/), anders wijkt de knop af van de checkout */
      var main = 0, acc = 0;
      items.forEach(function (it) {
        if (it.hidden) return;
        var p = parseFloat(it.getAttribute('data-price') || 0);
        if (it.classList.contains('item-main')) main += p; else acc += p;
      });
      var n = lookQty();
      var net = Math.round((main + acc * (1 - disc / 100)) * n * 100) / 100;
      var bruto = Math.round((main + acc) * n * 100) / 100;
      if (totalEl) totalEl.textContent = fmtEUR(net);
      if (oldEl) oldEl.textContent = (disc > 0 && net < bruto) ? (I18.insteadOf || 'i.p.v.') + ' ' + fmtEUR(bruto) : '';
      var saveEl = lookRoot.querySelector('[id^="sp-looksave"]');
      if (saveEl) {
        var besparing = Math.round((bruto - net) * 100) / 100;
        if (disc > 0 && besparing > 0) { saveEl.textContent = (I18.youSave || 'Je bespaart {b} ({p}%) op deze set').replace('{b}', fmtEUR(besparing)).replace('{p}', String(disc).replace('.', ',')); saveEl.hidden = false; }
        else { saveEl.hidden = true; }
      }
    }
    recalc();
    function addToCart(payload, done, fail) {
      var x = new XMLHttpRequest();
      x.open('POST', '/cart/add.js', true);
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('Accept', 'application/json');
      x.onload = function () { if (x.status >= 200 && x.status < 300) { try { sykTrackATC(JSON.parse(x.responseText)); } catch (e) {} if (done) done(); } else if (fail) fail(); };
      x.onerror = function () { if (fail) fail(); };
      x.send(JSON.stringify(payload));
    }
    function refreshCart(openPanel) {
      try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true })); } catch (e) {}
      sykVerversDrawer(openPanel);
    }
    /* los item: korte ✓-bevestiging, daarna weer toevoegbaar (geen permanente vergrendeling) */
    function flashBtn(btn, html) {
      btn.disabled = true; btn.classList.add('inset'); btn.innerHTML = '<i class="ti ti-check"></i>';
      setTimeout(function () { btn.disabled = false; btn.classList.remove('inset'); btn.innerHTML = html; }, 1600);
    }
    box.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.iadd') : null;
      if (!btn || btn.disabled) return;
      var it = btn.closest('.item'); if (!it) return;
      var vid = btn.getAttribute('data-vid');
      var sel = $('.ivar', it);
      if (sel && !btn.getAttribute('data-vid')) {
        if (!sel.value) { try { sel.focus(); } catch (x) {} return; }
        vid = sel.value;
      } else if (sel && sel.value) { vid = sel.value; }
      if (!vid) return;
      var orig = btn.innerHTML;
      btn.disabled = true;
      addToCart({ items: [{ id: vid, quantity: 1 }] }, function () { flashBtn(btn, orig); refreshCart(); }, function () { btn.disabled = false; });
    });
    /* native thema-stepper (.input-amount) handelt de +/- zelf af én vervangt het <input> bij init;
       daarom gedelegeerd herberekenen (een gecachte referentie zou stale zijn). */
    var amtEl = lookRoot.querySelector('.look-amount');
    if (amtEl) amtEl.addEventListener('click', function () { setTimeout(recalc, 0); });
    lookRoot.addEventListener('input', function (e) { if (e.target && e.target.closest && e.target.closest('.look-amount')) setTimeout(recalc, 0); });
    document.addEventListener('change', function (e) { if (e.target && (e.target.name === 'quantity' || (e.target.closest && e.target.closest('.look-amount')))) recalc(); });
    /* "Bestel de complete look" via DELEGATIE op lookRoot (net als .iadd): de native thema-stepper
       (.input-amount) herschrijft bij zijn init de .lookbuy-inhoud en VERVANGT daarmee de .lookcta-node —
       een direct op de knop gezette listener verliest die race en de knop "doet niets" (bug 02-07).
       Herstel van tekst/disabled loopt via een live lookup, want ook ná de klik kan de node vervangen worden. */
    lookRoot.addEventListener('click', function (e) {
      var cta = e.target && e.target.closest ? e.target.closest('.lookcta') : null;
      if (!cta || cta.disabled) return;
      var n = lookQty();
      var payload = [];
      var mv = selectedVar();
      if (mv && mv.available && mv.id) payload.push({ id: String(mv.id), quantity: currentQty() * n });
      /* accessoires krijgen een verborgen regel-eigenschap met het hoofdproduct-id: de discount function
         geeft ALLEEN korting op zo gemarkeerde regels (en alleen zolang het hoofdproduct in de mand zit) —
         uit mand-samenstelling alleen is het hoofdproduct niet af te leiden zodra producten wederzijds
         in elkaars aanbevolen-lijsten staan (USA-versiering-case: hoofdproduct kreeg ook korting) */
      var mainPid = lookRoot.getAttribute('data-main-pid') || '';
      items.forEach(function (it) {
        if (it.hidden || it.classList.contains('item-main')) return;
        var sel = $('.ivar', it);
        var ib = $('.iadd', it);
        var vid = (ib && ib.getAttribute('data-vid')) || (sel ? sel.value : '');
        if (vid) payload.push(mainPid ? { id: vid, quantity: n, properties: { _syk_set: mainPid } } : { id: vid, quantity: n });
      });
      if (!payload.length) return;
      var ctaOrig = cta.innerHTML;
      function restore() {
        var live = lookRoot.querySelector('.lookcta'); if (!live) return;
        live.disabled = false; live.innerHTML = ctaOrig;
      }
      cta.disabled = true; cta.innerHTML = '<i class="ti ti-check"></i> ' + (I18.added || 'Toegevoegd — kies evt. een andere maat');
      addToCart({ items: payload }, function () {
        refreshCart(true);
        setTimeout(function () { restore(); recalc(); }, 2200);
      }, restore);
    });
  }
  $all('.look').forEach(bindLook);
  /* comp-blok (recommendations) vervangt zijn hele element async: body-breed nabinden met debounce
     (observer op de container zelf mist een outerHTML-replace; de bound-guard maakt dit goedkoop) */
  (function () {
    var t = null;
    var mo = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { $all('.look').forEach(bindLook); syncCompMaat(); labelCompMaat(); sykPlaatsMaattabel(); }, 150);
    });
    try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  })();

  /* Maattabel-plaatsing (wens eigenaar 10-07, uitkomst design-jury): de losse volle-breedte rij onder
     de koopknop (~64px, mobile-first zonde van de ruimte) vervalt. De maattabel-link verhuist als compacte
     chip naar RECHTS op de 'Kies je maat'-regel, het pasvorm-advies naast het label LINKS, en de
     levertijd-legenda als caption DIRECT ONDER de maten-grid (pal onder de balkjes die hij verklaart).
     JS-verplaatsing i.p.v. liquid: blok-onafhankelijk (maattabel/pasvorm zit in een ánder blok dan de
     matenkop), idempotent, en herstelt na thema-herbouw. Verplaatsen (niet klonen) behoudt de tab-klik. */
  function sykPlaatsMaattabel() {
    var rij = document.querySelector('.syk-pdp .mlabel-rij');
    if (!rij) return;
    var sizes = document.querySelector('.syk-pdp .sizes');
    /* legenda naar onder de grid */
    var legend = rij.querySelector('.vdt-legend');
    if (legend && sizes && !legend.classList.contains('vdt-legend--onder')) {
      legend.classList.add('vdt-legend--onder');
      sizes.parentNode.insertBefore(legend, sizes.nextSibling);
    }
    /* 'Levertijd & voorraad' OP de legendaregel i.p.v. op een eigen regel eronder (melding eigenaar
       30-09: 'nu schiet alles een beetje naar beneden'). De legendaregel is maar 17px hoog en heeft
       rechts ruim plek over; de losse link kostte 44px extra en duwde de koopknop omlaag. Zelfde
       verplaatsings-pas als de legenda hierboven, dus geen extra sprong. Staat de legenda uit, dan
       blijft de link gewoon op zijn eigen plek staan. */
    var vrdLink = document.querySelector('.syk-pdp .syk-vrd-link');
    var legendOnder = document.querySelector('.syk-pdp .vdt-legend--onder');
    if (vrdLink && legendOnder && vrdLink.parentNode !== legendOnder) legendOnder.appendChild(vrdLink);
    var fitrow = document.querySelector('.syk-pdp .fitrow');
    if (fitrow) {
      var fit = fitrow.querySelector('.fit');
      var link = fitrow.querySelector('.tablelink');
      var mlabel = rij.querySelector('.mlabel');
      if (fit && !fit.getAttribute('data-syk-moved')) {
        fit.setAttribute('data-syk-moved', '1');
        if (mlabel && mlabel.parentNode === rij) rij.insertBefore(fit, mlabel.nextSibling); else rij.appendChild(fit);
      }
      if (link && !link.getAttribute('data-syk-moved')) {
        link.setAttribute('data-syk-moved', '1');
        link.classList.add('tablelink--chip');
        rij.appendChild(link);
      }
      if (!fitrow.querySelector('.tablelink, .fit')) fitrow.style.display = 'none';
    }
  }
  sykPlaatsMaattabel();
  setTimeout(sykPlaatsMaattabel, 300);
  setTimeout(sykPlaatsMaattabel, 1200);
  /* fase 2 (design-jury): subtiele puls op de maattabel-chip zodra de bezoeker een maat kiest —
     exact op het twijfelmoment. Eén keer per sessie, alleen bij een ECHTE maat-tik (niet de
     auto-select bij laden), en pure progressive enhancement (chip werkt zonder dit gewoon). CSS
     respecteert prefers-reduced-motion. */
  function sykMaattabelPuls() {
    try { if (sessionStorage.getItem('sykMtPuls')) return; } catch (e) {}
    var chip = document.querySelector('.syk-pdp .tablelink--chip');
    if (!chip) return;
    try { sessionStorage.setItem('sykMtPuls', '1'); } catch (e) {}
    chip.classList.add('tablelink--puls');
    setTimeout(function () { chip.classList.remove('tablelink--puls'); }, 4200);
  }
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.syk-pdp .sz:not(.out)')) setTimeout(sykMaattabelPuls, 60);
  });
  /* zichtbare maatkiezer in de comp-koop-rij: twee-weg-sync met de PDP-maatknoppen */
  function syncCompMaat() {
    var mv = null; try { mv = selectedVar(); } catch (e) {}
    if (!mv) return;
    $all('.syk-comp-maat').forEach(function (sel) { try { sel.value = String(mv.id); } catch (e) {} });
  }
  document.addEventListener('change', function (e) {
    var t2 = e.target;
    if (t2 && t2.classList && t2.classList.contains('syk-comp-maat')) {
      var b = document.querySelector('.syk-pdp .sz[data-id="' + t2.value + '"]');
      if (b) { b.click(); }
      else {
        var r = document.querySelector('input[name="id"][value="' + t2.value + '"]');
        if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      }
    }
    if (t2 && t2.name === 'id') setTimeout(syncCompMaat, 0);
  });
  document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('.syk-pdp .sz')) setTimeout(syncCompMaat, 0); });
  setTimeout(syncCompMaat, 400);

  /* ---- "Maak je look compleet": levertijd per item (incl. hoofdproduct) + maat-sync hoofdproduct ---- */
  (function lookItemDelivery() {
    var lookItems = $all('.look .item[data-sku]');
    if (!lookItems.length) return;
    function paintItem(it, d) {
      var t = it.querySelector('.idel-txt'); if (!t) return;
      var hasDate = d && !isNaN(d.getTime());
      t.textContent = hasDate ? inHuis(d) : (I18.tomorrow || 'Morgen in huis');
      /* latere datum (niet morgen) -> oranje, net als de levertijd-badge bovenaan; anders groen */
      var wrap = it.querySelector('.idel');
      if (wrap) wrap.classList.toggle('is-later', hasDate && isFastest(d) == false);
    }
    var seen = {}, skus = [];
    lookItems.forEach(function (it) { var s = it.getAttribute('data-sku'); if (s && !seen[s]) { seen[s] = 1; skus.push(s); } });
    if (skus.length) {
      fetch(BULK, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ products: skus.map(function (s) { return { sku: s, quantity: 1, available: true }; }) }) })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.products) ? data.products : {};
          var maxD = null;
          $all('.look .item[data-sku]').forEach(function (it) {
            var rec = products[it.getAttribute('data-sku')];
            var d = rec && rec.deliveryDate ? new Date(rec.deliveryDate) : null;
            paintItem(it, d);
            /* traagste accessoire onthouden (hoofdproduct telt per maat apart mee in labelCompMaat) */
            if (!it.classList.contains('item-main') && d && !isNaN(d.getTime()) && (!maxD || d > maxD)) maxD = d;
          });
          lookSlowest = maxD;
          labelCompMaat(); /* set-leverdatum in het witte venster bijwerken */
        })
        .catch(function () { /* API onbereikbaar: laat "Morgen in huis" staan */ });
    }
    /* hoofdproduct-regel: sku/levertijd + maatkiezer mee laten lopen met de gekozen maat */
    var mainItem = $('.look .item-main'); if (!mainItem) return;
    var ivarMain = mainItem.querySelector('.ivar-main');
    function syncMain() {
      var v = selectedVar(); if (!v) return;
      mainItem.setAttribute('data-sku', v.sku);
      if (ivarMain) { try { ivarMain.value = v.id; } catch (e) {} }
      if (DELIV && DELIV[v.sku]) paintItem(mainItem, DELIV[v.sku].deliveryDate ? new Date(DELIV[v.sku].deliveryDate) : null);
    }
    if (ivarMain) ivarMain.addEventListener('change', function () {
      var r = $('input[name="id"][value="' + ivarMain.value + '"]'); if (r) { r.checked = true; syncSelection(); }
      syncMain();
    });
    $all('.sz').forEach(function (b) { b.addEventListener('click', function () { setTimeout(syncMain, 0); }); });
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') syncMain(); });
    syncMain();
  })();

  /* ---- collectieslider-pijlen (per blok-instantie) ---- */
  $all('.cs-track').forEach(function (track) {
    var wrap = track.closest('.cs-wrap'); if (!wrap) return;
    var prev = wrap.querySelector('.cs-prev'), next = wrap.querySelector('.cs-next');
    function step() { var it = track.querySelector('.cs-item'); var w = it ? it.getBoundingClientRect().width : 92; return Math.max(1, Math.round((track.clientWidth - w) / (w + 18))) * (w + 18); }
    function sync() { if (!prev || !next) return; var max = track.scrollWidth - track.clientWidth - 1; prev.disabled = track.scrollLeft <= 0; next.disabled = track.scrollLeft >= max; }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: SYK_SMOOTH }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: SYK_SMOOTH }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ---- recent bekeken: pijlen + wishlist + localStorage-vulling ---- */
  (function () {
    var tracks = $all('.rv-track'); if (!tracks.length) return;
    tracks.forEach(function (track) {
      var sec = track.closest('.rv-sec') || track.parentNode;
      [].slice.call(sec.querySelectorAll('.rv-arrow')).forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = parseInt(b.getAttribute('data-rv-dir'), 10) || 1;
          track.scrollBy({ left: dir * Math.round(track.clientWidth * 0.8), behavior: SYK_SMOOTH });
        });
      });
      track.addEventListener('click', function (e) {
        var w = e.target.closest ? e.target.closest('.rv-wish') : null;
        if (w) { e.preventDefault(); e.stopPropagation(); w.classList.toggle('rv-on'); }
      });
    });

    var handle = CFG.handle || '';
    var firstSec = tracks[0].closest('.rv-sec');
    var max = parseInt((firstSec && firstSec.getAttribute('data-count')) || CFG.recentCount, 10) || 8;
    /* Gebruik de NATIVE theme-historie: localStorage 'recentlyViewedProduct' = [{productUrl, productId}, ...],
       die het thema zelf op ELKE productpagina bijwerkt. Zo loopt 'recent bekeken' exact synchroon met de
       rest van de site (en niet meer een losse, lege eigen lijst). Nieuwste eerst, huidige uitgesloten. */
    function read() {
      var arr = []; try { arr = JSON.parse(localStorage.getItem('recentlyViewedProduct') || '[]') || []; } catch (e) {}
      var out = [];
      for (var i = arr.length - 1; i >= 0; i--) {
        var u = arr[i] && arr[i].productUrl; if (!u) continue;
        /* Alleen echte product-URL's: /products/<handle>. Sla afbeeldings-/andere URL's over -
           een handle met een punt (.jpg/.png) gaf eerder fetch /products/<bestand>.js -> 404. */
        var m = String(u).split('?')[0].match(/\/products\/([^\/?#]+)\/?$/);
        var h = m && m[1];
        if (h && h.indexOf('.') === -1 && h !== handle && out.indexOf(h) < 0) out.push(h);
      }
      return out;
    }
    var list = read();

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function card(p) {
      var img = p.featured_image ? '<img src="' + esc(p.featured_image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '<i class="ti ti-photo" aria-hidden="true"></i>';
      var price = (p.price_min != null && p.price_max != null && p.price_min !== p.price_max)
        ? '<small>Vanaf</small> ' + fmtEUR((p.price_min || 0) / 100)
        : fmtEUR((p.price || 0) / 100);
      var sizes = (p.options_sizes || []).slice(0, 6).map(function (o) { return '<span class="rv-pill' + (o.available ? '' : ' rv-out') + '">' + esc(o.name) + '</span>'; }).join('');
      var dtxt = (CFG.fast || 'Voor 23:59 besteld = ').replace(/\s*$/, ' ') + (I18.wTomorrow || 'morgen') + DSUF, dcls = '', dicon = 'ti-truck';
      if (p.available === false) { dtxt = (I18.soldout || 'Uitverkocht'); dcls = ' rv-del-sold'; dicon = 'ti-ban'; }
      else if (p.delivery && !isNaN(p.delivery.getTime())) {
        if (isFastest(p.delivery)) {
          var nn = diffDays(p.delivery);
          dtxt = (nn <= 0 ? (I18.sToday || 'Vandaag') : (nn === 1 ? (I18.sTomorrow || 'Morgen') : dayName(p.delivery))) + DSUF;
        } else { dtxt = cap(dateShort(p.delivery)) + DSUF; dcls = ' rv-del-later'; }
      }
      return '<a class="rv-card" href="' + esc(p.url) + '">' +
        '<div class="rv-media">' + img + '<button type="button" class="rv-wish" aria-label="' + (I18.wishlist || 'Aan verlanglijst toevoegen') + '"><i class="ti ti-heart"></i></button></div>' +
        '<div class="rv-body"><div class="rv-name">' + esc(p.title) + '</div><div class="rv-price">' + price + '</div>' +
        (sizes ? '<div class="rv-sizes">' + sizes + '</div>' : '') +
        '<div class="rv-delivery' + dcls + '"><i class="ti ' + dicon + '"></i><span>' + esc(dtxt) + '</span></div></div></a>';
    }
    if (!list.length) { $all('.rv-empty').forEach(function (em) { em.hidden = false; }); return; }
    var slice = list.slice(0, max);
    Promise.all(slice.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (prods) {
      var built = [], items = [];
      prods.forEach(function (p) {
        if (!p) return;
        var sizeOpt = (p.options || []).indexOf('Maat') > -1 ? 'Maat' : ((p.options || [])[0] || '');
        var sizes = [];
        if (sizeOpt && sizeOpt !== 'Title' && (p.variants || []).length > 1) {
          var seen = {};
          (p.variants || []).forEach(function (v) {
            var name = v.options[(p.options || []).indexOf(sizeOpt)];
            if (name && name !== 'Default Title' && !seen[name]) { seen[name] = 1; sizes.push({ name: name, available: v.available }); }
          });
        }
        /* sku van de snelste leverbare variant (barcode of id) voor de levertijd-lookup */
        var vs = p.variants || [], pick = null;
        for (var k = 0; k < vs.length; k++) { if (vs[k].available) { pick = vs[k]; break; } }
        if (!pick) pick = vs[0];
        var sku = pick ? (pick.barcode || String(pick.id)) : '';
        if (sku) items.push({ sku: sku, quantity: 1, available: pick ? !!pick.available : false });
        built.push({ sku: sku, data: {
          url: p.url, title: p.title,
          featured_image: p.featured_image ? (p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=300') : '',
          price: p.price, price_min: p.price_min, price_max: p.price_max, options_sizes: sizes, available: p.available
        } });
      });
      function render(dmap) {
        var html = '';
        built.forEach(function (b) {
          var rec = dmap[b.sku];
          b.data.delivery = (rec && rec.deliveryDate) ? new Date(rec.deliveryDate) : null;
          html += card(b.data);
        });
        if (html) { tracks.forEach(function (t) { t.innerHTML = html; }); } else { $all('.rv-empty').forEach(function (em) { em.hidden = false; }); }
      }
      if (items.length) {
        fetch(BULK, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ products: items }) })
          .then(function (r) { return r.json(); })
          .then(function (data) { render((data && data.products) || {}); })
          .catch(function () { render({}); });
      } else { render({}); }
    }).catch(function () { $all('.rv-empty').forEach(function (em) { em.hidden = false; }); });
  })();

  /* ===== Thema-galerij verrijken: bestseller-badge + "1 / N"-teller + zoomknop (R5/R6) =====
     De thema-galerij (.l4pr) staat BUITEN .syk-pdp; classes hier zijn dus ongescoped. */
  function enhanceThemeGallery(force) {
    var ul = document.querySelector('.l4pr[data-media-size]');
    if (!ul) return;
    var box = (ul.closest && ul.closest('.l4pr-container')) || ul.parentNode;
    if (!box) return;
    /* WACHT tot het thema de slides in .swiper-wrapper heeft gezet; voegen we onze overlay eerder toe,
       dan verpakt het thema 'm mee als extra slide -> een extra (4e) paginatie-bolletje. force=true overslaat dit (galerij zonder Swiper). */
    if (!force && !ul.querySelector('.swiper-wrapper') && ul.querySelector(':scope > li')) return;
    /* al een overlay geplaatst? dan klaar. */
    if (ul.querySelector(':scope > .syk-gov')) return;
    /* anders eerst eerdere/misplaatste floaters opruimen (Swiper kan losse floaters als 'slide' verpakt hebben) */
    [].forEach.call(document.querySelectorAll('.l4pr-container .syk-gov, .l4pr-container .syk-gcount, .l4pr-container .syk-gzoom, .l4pr-container .syk-gbadge, .l4pr-container .syk-glabel'), function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
    /* overlay die EXACT de (vierkante) foto bedekt (top:0, width:100%, aspect-ratio uit --ratio) -> alle floaters
       op de foto-hoeken, los van de dots/paginatie-strook die ónder de foto in .l4pr zit. */
    var ov = document.createElement('li'); /* <li> i.p.v. <div>: geldige directe child van de <ul.l4pr> (a11y 'list'-audit), blijft absoluut gepositioneerd dus zelfde uitlijning */
    ov.className = 'syk-gov';

    /* alleen echte media-slides: geen palette-/sticky-<li>, moet een afbeelding of fancybox-anchor bevatten */
    /* slides: na Swiper-init zitten ze in .swiper-wrapper (geen directe <li> meer) -> descendant-query; clones overslaan */
    var slides = [].slice.call(ul.querySelectorAll('li.has-anchor, .swiper-slide')).filter(function (n) {
      return !(n.classList && (n.classList.contains('sticky') || n.classList.contains('swiper-slide-duplicate'))) && n.querySelector('a[data-fancybox], picture, img');
    });
    var total = parseInt(ul.getAttribute('data-media-size'), 10) || slides.length;

    /* bestseller-badge uit metaveld custom.galerij_badge (via SP_CFG.galleryBadge) — op de hoofdafbeelding */
    var badgeTxt = (CFG.galleryBadge || '').toString().trim();
    if (badgeTxt) {
      var badge = document.createElement('span');
      badge.className = 'syk-gbadge';
      badge.innerHTML = '<i class="ti ti-flame"></i>';
      badge.appendChild(document.createTextNode(badgeTxt));
      ov.appendChild(badge);
    }

    /* PDP-label uit metaveld custom.pdp_label (vaste opties, teksten/icoon via SP_CFG.galleryLabel) */
    var lblCfg = CFG.galleryLabel || {};
    var lblTxt = (lblCfg.text || '').toString().trim();
    if (lblTxt) {
      var glabel = document.createElement('span');
      glabel.className = 'syk-glabel' + (badgeTxt ? ' onder-badge' : '');
      if (lblCfg.icon) { var gli = document.createElement('i'); gli.textContent = lblCfg.icon; glabel.appendChild(gli); }
      glabel.appendChild(document.createTextNode(' ' + lblTxt));
      ov.appendChild(glabel);
    }

    /* 'Dit item bestaat uit' als zwevende chip linksonder op de foto (blok-setting zweef_mobiel;
       CSS toont de chip alleen <760px en verbergt dan de gewone regel in de kolom). COMPACT
       (melding eigenaar 09-07 'chip te groot'): alleen de INHOUD ('jas, broek'), zonder label —
       het icoontje zegt al dat het om de set-onderdelen gaat; het volledige label blijft op
       desktop in de kolom staan. */
    var dibBron = document.querySelector('.syk-pdp .dib-row.dib-zweef');
    if (dibBron) {
      var gdib = document.createElement('span');
      gdib.className = 'syk-gdib';
      var dibIco = dibBron.querySelector('.dib-ico i');
      if (dibIco) { var gdi = document.createElement('i'); gdi.className = dibIco.className; gdib.appendChild(gdi); }
      var gdtxt = document.createElement('span');
      var dibVal = dibBron.querySelector('.dib-val') || dibBron.querySelector('.dib-txt') || dibBron;
      gdtxt.textContent = (dibVal.textContent || '').trim();
      gdib.appendChild(gdtxt);
      ov.appendChild(gdib);
    }

    /* .l4pr (Swiper-container) = positioneringscontext; floaters worden DIRECTE kinderen ervan
       (siblings van .swiper-wrapper) -> Swiper laat ze met rust en ze overlappen exact de foto-viewport. */
    try { if (getComputedStyle(ul).position === 'static') ul.style.position = 'relative'; } catch (e) {}

    /* teller + zoomknop (CSS toont ze nu op desktop én mobiel, op de foto) */
    var counter = document.createElement('span');
    counter.className = 'syk-gcount';
    counter.innerHTML = '<i class="ti ti-photo"></i> <b class="syk-gc-n">1</b> / ' + total;
    ov.appendChild(counter);
    var num = counter.querySelector('.syk-gc-n');

    var zoom = document.createElement('button');
    zoom.type = 'button';
    zoom.className = 'syk-gzoom';
    zoom.setAttribute('aria-label', I18.zoom || 'Vergroot afbeelding');
    zoom.innerHTML = '<i class="ti ti-zoom-in"></i>';
    ov.appendChild(zoom);
    ul.appendChild(ov); /* overlay als directe child van .l4pr (Swiper laat niet-wrapper kinderen met rust) */

    /* overlay-hoogte = exact de fotohoogte (.swiper-wrapper), NIET de hele .l4pr (incl. dots-strook).
       Lost op dat de teller op desktop te ver naar beneden zakte bij niet-vierkante foto's
       (de CSS-fallback aspect-ratio:1 klopt alleen bij vierkante foto's). */
    function sizeGov() {
      /* METEN AAN .swiper-outer, NIET aan .swiper-wrapper (melding eigenaar 22-07, iPhone 17:
         'dit bestaat uit en de 1/6 gaan mee naar links'). De wrapper is precies het element waar
         Swiper zijn translate op zet, en getBoundingClientRect() telt die translate MEE. Stond de
         bezoeker op foto 2 en draaide sizeGov op dat moment, dan werd --syk-gov-l de slide-offset
         in plaats van 0 — en CSS-regel ~561 zet die var als left op de hele overlay.
         Live nagemeten op deze pagina (375px): wrapper-meting gaf 0 / -343 / -686 per foto,
         .swiper-outer gaf 0 / 0 / 0. Reproductie met -343px: chip sprong van x=10 naar x=-333 en
         de teller van 275 naar -68 — allebei buiten beeld — en dat herstelde NOOIT meer, ook niet
         bij terugkeren naar foto 1, want niets zet de var terug.
         De trigger verklaart ook 'soms wel soms niet': de resize-listener hieronder vuurt op iOS
         zodra de Safari-balk in- of uitklapt tijdens het scrollen. Gebeurt dat toevallig terwijl je
         niet op foto 1 staat, dan is de overlay weg; gebeurt het niet, dan lijkt alles in orde.
         .swiper-outer is de foto-viewport zelf en draagt nooit een translate. */
      var w = ul.querySelector('.swiper-outer') || ul.querySelector('.swiper-wrapper') || slides[0];
      if (!w) return;
      var wr = w.getBoundingClientRect();
      if (wr.height > 20) ov.style.height = wr.height + 'px';
      /* desktop: de miniaturen-kolom zit LINKS binnen dezelfde ul -> overlay uitlijnen op het echte fotogebied,
         anders valt de badge/label linksboven achter de thumbs (css leest deze vars; fallback 0/100%) */
      var ur = ul.getBoundingClientRect();
      if (wr.width > 40) {
        /* VANGNET (zelfde melding): het fotogebied begint nooit links van de <ul> en is nooit breder
           dan de <ul>. Meet een toekomstige wijziging tóch iets buiten die grenzen, dan schrijven we
           NIETS weg en houdt de overlay zijn vorige, goede waarde. Zo kan deze var de zwevers nooit
           meer buiten beeld duwen, ongeacht welk element er ooit gemeten wordt. */
        var govL = Math.round(wr.left - ur.left);
        var govW = Math.round(wr.width);
        var ulW = Math.round(ur.width);
        if (govL >= 0 && govL <= ulW && govW <= ulW + 1) {
          ov.style.setProperty('--syk-gov-l', govL + 'px');
          ov.style.setProperty('--syk-gov-w', govW + 'px');
        }
      }
    }
    sizeGov();
    [150, 500, 1200, 2400].forEach(function (t) { setTimeout(sizeGov, t); });
    window.addEventListener('resize', sizeGov, { passive: true });
    window.addEventListener('load', sizeGov);

    var activeIdx = 0;
    function setActive(i) { if (i >= 0 && i !== activeIdx) { activeIdx = i; num.textContent = (i + 1); } }

    /* actieve index: Swiper-API als het thema Swiper gebruikt (zo is het), anders scroll-detectie als fallback */
    var sw = ul.swiper || (ul.children[0] && ul.children[0].swiper);
    if (sw && typeof sw.on === 'function') {
      setActive(sw.realIndex || 0);
      sw.on('slideChange', function () { setActive(sw.realIndex || 0); });
    } else {
      var raf = 0;
      function computeActive() {
        raf = 0;
        var cR = ul.getBoundingClientRect();
        var cMid = cR.left + cR.width / 2;
        var best = 0, bestDist = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var r = slides[i].getBoundingClientRect();
          var d = Math.abs((r.left + r.width / 2) - cMid);
          if (d < bestDist) { bestDist = d; best = i; }
        }
        setActive(best);
      }
      function onScroll() { if (!raf) raf = requestAnimationFrame(computeActive); }
      ul.addEventListener('scroll', onScroll, { passive: true });
      if (box !== ul) box.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      computeActive();
    }

    /* zoom → open Fancybox direct met de galerij-bronnen (geen navigatie-risico, juiste startindex) */
    zoom.addEventListener('click', function (ev) {
      ev.preventDefault();
      var anchors = slides.map(function (li) { return li.querySelector('a[data-fancybox]'); }).filter(Boolean);
      if (window.Fancybox && anchors.length) {
        var srcs = anchors.map(function (a) {
          var href = a.getAttribute('href') || '';
          var img = /\.(jpe?g|png|webp|gif|avif)(\?|$)/i.test(href);
          return img ? { src: href, type: 'image' } : { src: href };
        });
        var actA = slides[activeIdx] ? slides[activeIdx].querySelector('a[data-fancybox]') : null;
        var start = actA ? anchors.indexOf(actA) : 0;
        window.Fancybox.show(srcs, { startIndex: start < 0 ? 0 : start });
        return;
      }
      var la = slides[activeIdx] || slides[0];
      var a2 = la && la.querySelector('a[data-fancybox]');
      if (a2) { a2.click(); }
    });
  }
  enhanceThemeGallery();
  setTimeout(function () { enhanceThemeGallery(); }, 700);   /* na de thema-slider-init opnieuw */
  setTimeout(function () { enhanceThemeGallery(); }, 1800);
  setTimeout(function () { enhanceThemeGallery(true); }, 2800); /* fallback: galerij zonder Swiper */
  /* her-uitvoeren wanneer het thema de galerij opnieuw opbouwt (variant-foto-swap, AJAX-navigatie):
     dan zijn onze floaters weg -> de observer voegt ze opnieuw toe (idempotente guard voorkomt dubbel). */
  try {
    var __sykGalObs = new MutationObserver(function () { clearTimeout(window.__sykGalT); window.__sykGalT = setTimeout(enhanceThemeGallery, 150); });
    __sykGalObs.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
  /* maten in slider-weergave (blok-setting size_layout): geselecteerde maat bij laden centreren,
     anders staat de gekozen maat buiten beeld als het product veel maten heeft. Plus (melding
     eigenaar 09-07: 'XXL niet zichtbaar'): zolang er rechts meer maten staan een fade aan de
     rechterrand — GEEN pijltje (wens eigenaar: 'zonder pijltje, met een fade'); de half
     afgesneden knop + de fade maken het scrollen duidelijk. De fade verdwijnt aan het einde. */
  function sykSzSliderCenter() {
    [].forEach.call(document.querySelectorAll('.syk-pdp .sizes--slider'), function (rail) {
      if (rail.scrollWidth > rail.clientWidth + 4 && !rail.querySelector('.sz-schaduw')) {
        var sch = document.createElement('span');
        sch.className = 'sz-schaduw';
        sch.setAttribute('aria-hidden', 'true');
        rail.appendChild(sch);
        var upd = function () { rail.classList.toggle('sz-eind', rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 6); };
        rail.addEventListener('scroll', upd, { passive: true });
        upd();
      }
      var sel = rail.querySelector('.sz.sel');
      if (sel && rail.scrollWidth > rail.clientWidth) rail.scrollLeft = Math.max(0, sel.offsetLeft - (rail.clientWidth - sel.offsetWidth) / 2);
    });
  }
  setTimeout(sykSzSliderCenter, 80);
  setTimeout(sykSzSliderCenter, 900); /* na eventuele thema-herbouw/variant-swap */

  /* ==========================================================================
     LEVERTIJD & VOORRAAD-PANEEL (wens eigenaar 30-09, naar voorbeeld feestkleding365).
     Probleem dat het oplost: staat er meer voorraad aan te komen, dan zag de klant niet
     WANNEER die binnenkomt en hoeveel hij nú al kan krijgen. Dit paneel toont per maat:
     hoeveel er op de eerste datum leverbaar is, hoeveel op de volgende, en laat hem per maat
     een aantal kiezen. De traagste gekozen maat bepaalt de datum van de HELE bestelling
     (alles gaat in één zending) — live geverifieerd tegen het bema-endpoint: S(2)+M(5) gaf
     2026-10-05 = max(10-01, 10-05), S(2)+M(1) gaf 10-01. Daarom rekenen we de totaaldatum
     CLIENT-SIDE uit de staffels: geen extra call per wijziging.
     PRESTATIE (eis eigenaar: 'mobile first en super snel'): niets gebeurt bij het laden van de
     pagina. Markup wordt pas bij de eerste opening gebouwd en de staffels worden pas dán
     opgehaald (1 kleine call per maat, parallel, daarna uit de bestaande STAFFEL-cache).
     Opt-in via syk_pdp_voorraad; de knop wordt server-side gerenderd (geen layout-sprong).
     ========================================================================== */
  (function () {
    var trigger = $('.syk-vrd-link'); if (!trigger) return;
    /* EIGEN escape-helper: de esc() elders in dit bestand staat in een GENESTE scope en is
       hier niet bereikbaar — live gaf dat 'esc is not defined' zodra je het paneel opende,
       waardoor er niets verscheen. (Mijn proefopstelling bundelde esc apart en verhulde dat.) */
    function vrdEsc(x) { return String(x == null ? '' : x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    var paneel = null, rijen = [], T = {}, kolom1 = null, kolommen = [], kolSnel = [];
    ['kop', 'tot', 'hint', 'deel', 'aantal', 'cta', 'stuks', 'maat', 'uit', 'verw', 'pre', 'prelev', 'pretitel', 'preuitleg', 'alles', 'bevat', 'etitel', 'etekst', 'etekstg', 'cutopen', 'cutdicht', 'cutweekend'].forEach(function (k) {
      T[k] = trigger.getAttribute('data-t-' + k) || '';
    });
    var prodTitel = trigger.getAttribute('data-titel') || '';
    var vendor = trigger.getAttribute('data-vendor') || '';
    var cutAan = trigger.getAttribute('data-cut') === '1';
    /* Merken waarvan de leverancier de VOLGENDE DAG levert (instelling, bevestigd door de eigenaar
       05-10: Widmann via Finidi, PartyXplosion, PXP). Vergelijken zonder hoofdletters/spaties: het
       veld wordt met de hand getypt. */
    var volgdagMerken = (trigger.getAttribute('data-volgdag') || '').split(',')
      .map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
    var merkVolgdag = volgdagMerken.indexOf(String(vendor).trim().toLowerCase()) > -1;
    /* TESTSTAND (wens eigenaar 05-10): '?syk_cut=16:00' achter een productadres zet de cutoff-regel
       aan voor ALLEEN deze bezoeker en gebruikt die tijd als besteltijd van dit merk. '?syk_cut=1'
       zet alleen de regel aan, met de echte tijden. Klanten zien niets; econcepts en
       levertijden.json blijven ongemoeid. LET OP: de leverdatums komen nog steeds uit econcepts —
       die schuiven op de testtijd NIET mee, alleen de tekst. */
    var testCut = (function () { var m = /[?&]syk_cut=([^&#]+)/.exec(location.search); return m ? decodeURIComponent(m[1]) : null; })();
    var testTijd = (testCut && minutenVan(testCut) !== null) ? testCut : null;
    if (testCut) cutAan = true;
    function cutoffMetTest() {
      return cutoffLaad().then(function (c) {
        if (c && testTijd && vendor) {
          var b = c[vendor] || c['default'] || {};
          c[vendor] = { cutoff: testTijd, werkdagen: b.werkdagen, per_dag: b.per_dag };
        }
        return c;
      });
    }
    /* verwachte binnenkomst per uitverkochte maat, uit het metafield dat de eigenaar in de
       thema-instellingen kiest (syk_pdp_voorraad_mf). Sleutel = dezelfde sku als naar de
       levertijd-API. Een geldige datum tonen we in ons eigen formaat; staat er tekst in
       (bv. 'eind oktober'), dan komt die letterlijk te staan. */
    var verwMap = {}, preSet = {};
    /* per render opnieuw inlezen i.p.v. één keer bij het laden: het thema kan de sectie herbouwen
       (editor, variantwissel) en dan kunnen deze attributen veranderen. Maakt het bovendien
       testbaar zonder herladen. */
    function leesAttributen() {
      try { verwMap = JSON.parse(trigger.getAttribute('data-verw') || '{}') || {}; } catch (e) { verwMap = {}; }
      preSet = {};
      try { (JSON.parse(trigger.getAttribute('data-pre') || '[]') || []).forEach(function (k) { preSet[k] = 1; }); } catch (e) { preSet = {}; }
    }
    leesAttributen();
    /* PRE-ORDER: varianten waarvan Shopify zegt dat doorverkopen aanstaat terwijl de voorraad op is.
       Zolang de custom app die schakelaar niet omzet is deze lijst leeg en verandert er niets; zet hij
       hem om, dan wordt de rij vanzelf bestelbaar met de verwachte datum uit het metafield. */
    function verwachtDatum(sku) {
      var v = verwMap[sku]; if (!v) return null;
      var d = new Date(v); return isNaN(d.getTime()) ? null : d;
    }
    function datumLang(d) { try { return d.toLocaleDateString(LOC, { day: 'numeric', month: 'long', year: 'numeric' }); } catch (e) { return ''; } }
    function subUitleg() {
      var d = null;
      rijen.forEach(function (rij) {
        if (!rij.classList.contains('syk-vrd-rij--pre')) return;
        var qEl = rij.querySelector('.syk-vrd-q');
        if (!qEl || (parseInt(qEl.value, 10) || 0) < 1) return;
        var dd = verwachtDatum(rij.getAttribute('data-sku'));
        if (dd && (!d || dd > d)) d = dd;
      });
      return (T.preuitleg || '').replace('{d}', d ? datumLang(d) : '');
    }
    function verwachtTekst(sku) {
      var v = verwMap[sku]; if (!v) return '';
      var d = new Date(v);
      return T.verw + ' ' + (isNaN(d.getTime()) ? String(v) : kolomLabel(d));
    }

    /* hoogste bestelbare aantal = de laatste staffeltrap; daarboven kan bema niet leveren en
       gaf tierDate null -> de rij bleef ten onrechte groen en de totaaldatum negeerde die maat
       (node-test 30-09: maat S heeft er 6, bij 7 verdween de datum). Daarom klemmen we de invoer. */
    function maxVan(t) { return (t && t.length) ? (t[t.length - 1].available || 0) : Infinity; }
    function klem(inp) {
      var rij = inp.closest('.syk-vrd-rij');
      var mx = maxVan(STAFFEL[rij.getAttribute('data-sku')]);
      var n = Math.max(0, parseInt(inp.value, 10) || 0);
      if (n > mx) n = mx;
      if (String(n) !== inp.value) inp.value = n;
    }
    /* De leverancier geeft bij ruime voorraad een standaardgetal rond de 10.000 terug (gezien:
       10.002 / 10.009 / 10.044). Dat is geen echte telling en oogt raar in de kolom, dus vanaf de
       ingestelde drempel tonen we een eigen tekst ('100+'). Het BESTELBARE maximum blijft wel het
       echte getal — we verbergen alleen de weergave, we beperken niets. */
    var veelVanaf = parseInt(trigger.getAttribute('data-veel'), 10);
    if (!(veelVanaf > 0)) veelVanaf = 10000;
    var veelTekst = trigger.getAttribute('data-veeltekst') || '100+';
    function toonAantal(n) { return n >= veelVanaf ? veelTekst : String(n); }
    /* Shopify noemt de variant van een product ZONDER echte varianten altijd 'Default Title' —
       in elke winkeltaal diezelfde Engelse placeholder. Dat is geen maat en hoort niet in de kolom
       (melding eigenaar 30-09, product 'Levensechte vis 55cm'); dan tonen we de producttitel. */
    function maatLabel(v) {
      var t = String(v && v.title || '').trim();
      if (!t || /^default title$/i.test(t)) return prodTitel || t;
      return t;
    }
    /* in welke getoonde kolom valt deze datum? Na de laatste kolom = de laatste (meer dan drie bronnen) */
    function kolIndex(dt) {
      if (!dt || !kolommen.length) return -1;
      var x = sod(dt).getTime();
      for (var i = 0; i < kolommen.length; i++) { if (sod(kolommen[i]).getTime() === x) return i; }
      return x > sod(kolommen[kolommen.length - 1]).getTime() ? kolommen.length - 1 : -1;
    }
    function kolomLabel(d) { /* 'morgen' / 'do 8 okt' — zelfde formatters als de rest van de PDP */
      return d ? etaShort(d).toLowerCase() : '';
    }
    /* Staffels ophalen. DRIE snelheidsmaatregelen (melding eigenaar 30-09: 'openen duurt lang';
       gemeten: elk verzoek 0,8-1,1s bij de leverancier, parallel dus ~1,1s wachten):
       1. alleen LEVERBARE maten bevragen — voor uitverkochte komt er toch een lege staffel terug
          (gemeten bij 4 van de 4), hier scheelde dat 3 van de 6 verzoeken;
       2. `opElk` wordt per binnengekomen antwoord aangeroepen, zodat de getallen binnendruppelen
          in plaats van dat je op de traagste wacht;
       3. zie `voorverwarm` onderaan: bij het aanraken/hoveren van de knop begint het ophalen al. */
    var haalBezig = null;
    function haalStaffels(opElk) {
      var doel = VARS.filter(function (v) { return v.sku && v.available; });
      return Promise.all(doel.map(function (v) {
        if (STAFFEL[v.sku]) return Promise.resolve();
        return fetch(STAFFEL_URL, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ products: [{ sku: v.sku, quantity: 1 }] }) })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) { STAFFEL[v.sku] = (d && d.length) ? d : []; if (opElk) opElk(); })
          .catch(function () { STAFFEL[v.sku] = []; if (opElk) opElk(); });
      }));
    }
    /* alvast ophalen zodra de bezoeker de knop aanraakt of eroverheen gaat: dat is het moment
       waarop hij hem gaat indrukken, dus die honderden milliseconden zijn gratis winst. */
    function voorverwarm() {
      if (!haalBezig) haalBezig = haalStaffels();
      if (cutAan) cutoffMetTest().then(function () { if (paneel) herbereken(); });
    }

    function bouw() {
      paneel = document.createElement('div');
      paneel.className = 'syk-vrd';
      paneel.innerHTML =
        '<div class="syk-vrd-back"></div>' +
        '<div class="syk-vrd-kaart" role="dialog" aria-modal="true" aria-label="' + vrdEsc(T.kop) + '">' +
          /* sleepgreep: maakt op mobiel zichtbaar dat je het paneel omlaag kunt vegen */
          '<div class="syk-vrd-greep" aria-hidden="true"><span></span></div>' +
          '<div class="syk-vrd-kop">' +
            '<div class="syk-vrd-kopt"><b>' + vrdEsc(T.kop) + '</b><span>' + vrdEsc(prodTitel) + '</span></div>' +
            /* kruisje als inline-SVG: de klasse ti-x bestaat NIET in onze iconenset (gecontroleerd
               30-09), een <i class="ti ti-x"> bleef dus leeg en het paneel oogde onsluitbaar */
            '<button type="button" class="syk-vrd-x" aria-label="Sluiten">' +
              '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="syk-vrd-body"><div class="syk-vrd-laad">…</div></div>' +
          '<div class="syk-vrd-voet">' +
            '<p class="syk-vrd-totlab"><i class="ti ti-truck" aria-hidden="true"></i>' + vrdEsc(T.tot) + '</p>' +
            '<p class="syk-vrd-tot"></p>' +
            '<p class="syk-vrd-sub"></p>' +
            '<p class="syk-vrd-cut" hidden></p>' +
            '<button type="button" class="syk-vrd-cta" disabled></button>' +
            /* alleen bij een MIX van voorradige en pre-orderartikelen: dan valt er iets te kiezen */
            '<div class="syk-vrd-eerder" hidden>' +
              '<svg width="21" height="21" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5v-9Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M3.5 7.5 12 12m0 0 8.5-4.5M12 12v9" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>' +
              '<span><b>' + vrdEsc(T.etitel) + '</b><i>' + vrdEsc(T.etekst) + '</i></span>' +
            '</div>' +
          '</div>' +
        '</div>';
      /* de groene/oranje accenten uit de instelbare levertijd-kleuren halen, zodat het
         paneel exact matcht met de bolletjes op de maatknoppen */
      var knopPx = parseInt(trigger.getAttribute('data-knop'), 10);
      paneel.style.setProperty('--syk-vrd-knop', (knopPx > 0 ? knopPx : 32) + 'px');
      paneel.style.setProperty('--syk-c-fast', CFG.cFast || '#1f9d57');
      paneel.style.setProperty('--syk-c-later', CFG.cLater || '#d9650a');
      document.body.appendChild(paneel);
      paneel.querySelector('.syk-vrd-x').addEventListener('click', sluit);
      paneel.querySelector('.syk-vrd-back').addEventListener('click', sluit);
      /* omlaag vegen om te sluiten (wens eigenaar 30-09). Alleen onder 768px en alleen vanaf de
         greep/kop — niet vanaf de lijst, anders kaap je het normale scrollen. Meer dan 80px of een
         snelle flick sluit; anders veert de kaart terug. */
      (function () {
        var kaart = paneel.querySelector('.syk-vrd-kaart');
        var grijp = [paneel.querySelector('.syk-vrd-greep'), paneel.querySelector('.syk-vrd-kop')];
        var y0 = null, dy = 0, t0 = 0;
        function start(e) {
          if (window.innerWidth >= 768 || !e.touches || e.touches.length !== 1) return;
          y0 = e.touches[0].clientY; dy = 0; t0 = Date.now(); kaart.style.transition = 'none';
        }
        function beweeg(e) {
          if (y0 === null) return;
          dy = Math.max(0, e.touches[0].clientY - y0);
          if (dy > 0) { kaart.style.transform = 'translateY(' + dy + 'px)'; if (e.cancelable) e.preventDefault(); }
        }
        function stop() {
          if (y0 === null) return;
          var snel = dy > 24 && (Date.now() - t0) < 260;
          kaart.style.transition = ''; kaart.style.transform = '';
          if (dy > 80 || snel) sluit();
          y0 = null;
        }
        grijp.forEach(function (el) {
          if (!el) return;
          el.addEventListener('touchstart', start, { passive: true });
          el.addEventListener('touchmove', beweeg, { passive: false });
          el.addEventListener('touchend', stop);
          el.addEventListener('touchcancel', stop);
        });
      })();
      paneel.querySelector('.syk-vrd-cta').addEventListener('click', inWinkelwagen);
      /* plus/min en typen: één keer vastgelegd op de body-container (zie de notitie in vulTabel) */
      var body0 = paneel.querySelector('.syk-vrd-body');
      body0.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-vstep]') : null; if (!b) return;
        var inp = b.parentNode.querySelector('.syk-vrd-q'); if (!inp) return;
        inp.value = (parseInt(inp.value, 10) || 0) + parseInt(b.getAttribute('data-vstep'), 10);
        klem(inp); herbereken();
      });
      body0.addEventListener('input', function (e) { if (e.target.classList.contains('syk-vrd-q')) { klem(e.target); herbereken(); } });
      /* uitlegballon bij pre-order: openen via het info-icoon, sluiten via het kruisje, een klik
         ernaast of Escape. Altijd maar één tegelijk open. */
      function sluitTips() {
        [].forEach.call(paneel.querySelectorAll('.syk-vrd-tip'), function (t) { t.hidden = true; });
        [].forEach.call(paneel.querySelectorAll('.syk-vrd-preinfo'), function (b) { b.setAttribute('aria-expanded', 'false'); });
      }
      /* LET OP: op het hele paneel, niet op de lijst-container. De info-knop in de VOET zit buiten
         .syk-vrd-body, dus daar kwam de klik nooit aan (melding eigenaar 30-09: 'tooltip onderin
         werkt niet'). */
      paneel.addEventListener('click', function (e) {
        var info = e.target.closest ? e.target.closest('.syk-vrd-preinfo') : null;
        var dicht = e.target.closest ? e.target.closest('.syk-vrd-tipx') : null;
        if (dicht) { sluitTips(); return; }
        if (info) {
          var tip = info.parentNode.querySelector('.syk-vrd-tip');
          var open = tip.hidden;
          sluitTips();
          if (open) { tip.hidden = false; info.setAttribute('aria-expanded', 'true'); }
          return;
        }
        if (!(e.target.closest && e.target.closest('.syk-vrd-tip'))) sluitTips();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sluitTips(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && paneel && paneel.classList.contains('open')) sluit(); });
    }
    /* Tabel METEEN tonen met alle maten en kiezers; de getallen en kolomdatums komen erin zodra de
       leverancier antwoordt. Zo staat het paneel er direct in plaats van na ~1 seconde wachten. */
    function vulTabel() {
      leesAttributen();
      var doel = VARS.filter(function (v) { return v.sku; });
      var body = paneel.querySelector('.syk-vrd-body');
      if (!doel.length) { body.innerHTML = '<p class="syk-vrd-leeg">' + vrdEsc(T.deel) + '</p>'; return; }
      body.innerHTML =
        '<div class="syk-vrd-tabel">' +
          '<div class="syk-vrd-hr">' +
            '<span class="syk-vrd-hmaat">' + vrdEsc(T.maat) + '</span>' +
            '<span class="syk-vrd-hd syk-vrd-hd1"><b></b><i>max.</i></span>' +
            '<span class="syk-vrd-hd syk-vrd-hd2"><b></b><i>max.</i></span>' +
            '<span class="syk-vrd-hd syk-vrd-hd3"><b></b><i>max.</i></span>' +
            '<span class="syk-vrd-ha">' + vrdEsc(T.aantal) + '</span>' +
          '</div>' +
          doel.map(function (v) {
            if (preSet[v.sku]) {
              /* Ontwerp gekozen door eigenaar 30-09: kalender-badge + info-icoon dat een uitlegballon
                 opent. Bewust GEEN voorraadgetal in deze rij — voor een pre-order bestaat dat niet,
                 en een getal verzinnen zou een belofte zijn. De datum staat in de ballon. */
              var dPre = verwachtDatum(v.sku);
              var uitleg = (T.preuitleg || '').replace('{d}', dPre ? datumLang(dPre) : '');
              return '<div class="syk-vrd-rij syk-vrd-rij--pre" data-sku="' + vrdEsc(v.sku) + '" data-id="' + vrdEsc(v.id) + '">' +
                '<span class="syk-vrd-maat">' + vrdEsc(maatLabel(v)) + '</span>' +
                '<span class="syk-vrd-pre">' +
                  '<b class="syk-vrd-prebadge">' +
                    '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3.5" y="5" width="17" height="15" rx="2.5" stroke="currentColor" stroke-width="1.8"/><path d="M3.5 9.5h17M8 3.5v3M16 3.5v3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
                    vrdEsc(T.pre) + '</b>' +
                  '<button type="button" class="syk-vrd-preinfo" aria-label="' + vrdEsc(T.pretitel) + '" aria-expanded="false">' +
                    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/><path d="M12 11v5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="7.8" r="1.15" fill="currentColor"/></svg>' +
                  '</button>' +
                  '<span class="syk-vrd-tip" hidden>' +
                    '<b>' + vrdEsc(T.pretitel) + '</b>' +
                    '<span>' + vrdEsc(uitleg) + '</span>' +
                    '<button type="button" class="syk-vrd-tipx" aria-label="Sluiten">' +
                      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>' +
                    '</button>' +
                  '</span>' +
                '</span>' +
                /* Melding eigenaar 07-10: '100+' onder een kolom 'za 10 okt' las als '100+ stuks op
                   zaterdag'. Nu staat daar de verwachte datum zelf (oranje); zonder datum het streepje. */
                '<span class="syk-vrd-n syk-vrd-n2 syk-vrd-predatum">' + vrdEsc(dPre ? kolomLabel(dPre) : '\u2013') + '</span>' +
                '<span class="syk-vrd-n syk-vrd-n3 syk-vrd-predatum">' + vrdEsc(dPre ? kolomLabel(dPre) : '\u2013') + '</span>' +
                '<span class="syk-vrd-step"><button type="button" data-vstep="-1" aria-label="' + vrdEsc(T.aantal + ' ' + maatLabel(v) + ' -1') + '">' +
                '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></button>' +
                '<input type="number" class="syk-vrd-q" value="0" min="0" autocomplete="off" inputmode="numeric" aria-label="' + vrdEsc(T.aantal + ' ' + maatLabel(v)) + '">' +
                '<button type="button" data-vstep="1" aria-label="' + vrdEsc(T.aantal + ' ' + maatLabel(v) + ' +1') + '">' +
                '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></button></span>' +
              '</div>';
            }
            if (!v.available) {
              /* uitverkochte maat: geen kiezer (niet bestelbaar tot pre-order live is). De verwachte
                 binnenkomst komt uit het gekozen variant-metafield; laat die leeg, dan 'Uitverkocht'. */
              var mfv = verwMap[v.sku];
              var uitTekst = T.uit, heeftDatum = false;
              if (mfv) {
                var dm = new Date(mfv);
                uitTekst = T.verw + ' ' + (isNaN(dm.getTime()) ? String(mfv) : kolomLabel(dm));
                heeftDatum = true;
              }
              return '<div class="syk-vrd-rij syk-vrd-rij--uit" data-sku="' + vrdEsc(v.sku) + '">' +
                '<span class="syk-vrd-maat">' + vrdEsc(maatLabel(v)) + '</span>' +
                '<span class="syk-vrd-uit' + (heeftDatum ? ' heeft-datum' : '') + '">' + vrdEsc(uitTekst) + '</span>' +
              '</div>';
            }
            return '<div class="syk-vrd-rij" data-sku="' + vrdEsc(v.sku) + '" data-id="' + vrdEsc(v.id) + '">' +
              '<span class="syk-vrd-maat">' + vrdEsc(maatLabel(v)) + '</span>' +
              '<span class="syk-vrd-n syk-vrd-n1 leeg">·</span>' +
              '<span class="syk-vrd-n syk-vrd-n2 leeg">·</span>' +
              '<span class="syk-vrd-n syk-vrd-n3 leeg">·</span>' +
              '<span class="syk-vrd-step"><button type="button" data-vstep="-1" aria-label="' + vrdEsc(T.aantal + ' ' + maatLabel(v) + ' -1') + '">' +
              '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></button>' +
              '<input type="number" class="syk-vrd-q" value="0" min="0" autocomplete="off" inputmode="numeric" aria-label="' + vrdEsc(T.aantal + ' ' + maatLabel(v)) + '">' +
              '<button type="button" data-vstep="1" aria-label="' + vrdEsc(T.aantal + ' ' + maatLabel(v) + ' +1') + '">' +
              '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></button></span>' +
            '</div>';
          }).join('') +
        '</div>';
      rijen = [].slice.call(body.querySelectorAll('.syk-vrd-rij'));
      /* LET OP: de plus/min-afhandeling hangt NIET hier maar in bouw(). Die luistert op
         .syk-vrd-body, en dat element blijft bestaan als we de inhoud opnieuw opbouwen — zette je
         de listener hier, dan kwam er bij elke heropening één bij en telde plus in stappen van 2
         (live betrapt 30-09: één klik gaf 0 -> 2). */
      vulGetallen();
    }
    /* de getallen en kolomdatums (her)invullen — wordt per binnengekomen antwoord aangeroepen en
       raakt de ingevulde aantallen NIET aan, zodat je alvast kunt kiezen terwijl het laadt */
    function vulGetallen() {
      if (!paneel || !rijen.length) return;
      var datums = [];
      VARS.filter(function (v) { return v.sku && v.available; }).forEach(function (v) {
        (STAFFEL[v.sku] || []).forEach(function (t) {
          if (t.deliveryDate && datums.indexOf(t.deliveryDate) === -1) datums.push(t.deliveryDate);
        });
      });
      datums.sort();
      /* DRIE BRONNEN (gemeten 05-10, Hulk-shirt na 15:00): eigen voorraad morgen, Finidi overmorgen,
         Milaan vrijdag. econcepts schuift de Finidi-voorraad bij zijn cutoff van morgen naar
         overmorgen, als APARTE trap. Met twee kolommen viel Milaan dan stil weg (geen kolom, geen
         '100+') terwijl de voet bij een groot aantal wel 'vrijdag' zei — een datum uit het niets.
         Nu maximaal drie datumkolommen; komen er ooit meer, dan tellen die mee in de laatste. */
      var kol = datums.slice(0, 3);
      kolommen = kol.map(function (x) { return new Date(x); });
      var d1 = kol[0], d2 = kol[1];
      kolom1 = d1 ? new Date(d1) : null;   /* referentie voor 'snelst mogelijk', zie herbereken */
      /* GROEN = SNEL (wens eigenaar 06-10: 'ik wil dat morgen ook groen is, dat is toch super
         snel?'). Een kolom is groen als hij de eerste is (30-09: bij een product waar vrijdag het
         snelst is, hoort vrijdag groen) OF als hij vandaag/morgen is — ook als dat de tweede kolom
         is, zoals na een leveranciers-cutoff (morgen = Finidi, eerste kolom = eigen voorraad). */
      kolSnel = kol.map(function (x, i) { return i === 0 || diffDays(new Date(x)) <= 1; });
      ['.syk-vrd-hd1 b', '.syk-vrd-hd2 b', '.syk-vrd-hd3 b'].forEach(function (sel, i) {
        var h = paneel.querySelector(sel);
        if (h) h.textContent = kol[i] ? kolomLabel(new Date(kol[i])) : '';
      });
      /* EEN BRON = EEN KOLOM (melding eigenaar 05-10, Groovy Hippie pak Odile). De kolommen zijn op
         DATUM gebouwd: kolom 2 bestaat alleen als er een tweede leverdatum is. Hebben alle maten
         dezelfde ene datum, dan tekenden we toch een lege tweede kolom ('max.' zonder datum, overal
         een streepje) en dat leest als een tweede magazijn dat er niet is: een artikel ligt bij ons
         OF bij de leverancier. Dan klappen we in tot een kolom.
         Pas inklappen als ALLE maten binnen zijn (de antwoorden komen een voor een), anders klapt
         hij in en weer uit zodra een latere maat alsnog een tweede datum blijkt te hebben.
         Een pre-orderrij houdt de tweede kolom: daar staat de verwachte datum (sinds 07-10). */
      var heeftPre = rijen.some(function (r) { return r.classList.contains('syk-vrd-rij--pre'); });
      var alleBinnen = VARS.filter(function (v) { return v.sku && v.available; })
        .every(function (v) { return STAFFEL[v.sku] !== undefined; });
      if (d2 || heeftPre) paneel.classList.remove('een-kolom');
      else if (d1 && alleBinnen) paneel.classList.add('een-kolom');
      /* het aantal datums groeit alleen terwijl de antwoorden binnenkomen, dus uitklappen naar drie
         kan meteen; terug naar twee gebeurt alleen bij een nieuwe opening */
      paneel.classList.toggle('drie-kolommen', kol.length >= 3);
      rijen.forEach(function (rij) {
        var cel = [rij.querySelector('.syk-vrd-n1'), rij.querySelector('.syk-vrd-n2'), rij.querySelector('.syk-vrd-n3')];
        if (!cel[0] || !cel[1]) return;              /* uitverkochte rij of pre-orderrij */
        var t = STAFFEL[rij.getAttribute('data-sku')];
        if (!t) return;                               /* antwoord nog onderweg: puntje laten staan */
        var n = [0, 0, 0];
        t.forEach(function (x) {
          var i = kol.indexOf(x.deliveryDate);
          /* een datum na de laatste kolom (meer dan drie bronnen) telt mee in de laatste kolom */
          if (i === -1 && kol.length && x.deliveryDate > kol[kol.length - 1]) i = kol.length - 1;
          if (i > -1) n[i] = Math.max(n[i], x.available); /* available is cumulatief: hoogste telt */
        });
        cel.forEach(function (c, i) {
          if (!c) return;
          c.textContent = n[i] ? toonAantal(n[i]) : '\u2013';
          c.classList.toggle('leeg', !n[i]);
          c.classList.toggle('snel', !!kolSnel[i]);
        });
      });
      herbereken();
    }
    /* de traagste gekozen maat bepaalt de datum van de hele bestelling */
    function herbereken() {
      var totaal = 0, traagste = null, aantalPre = 0, aantalVoorraad = 0;
      var cutMin = null, cutTxt = '', cutLev = false, cutWerk = null, kand = [];
      var klok = (cutAan && CUTOFF) ? klokAmsterdam() : null;
      rijen.forEach(function (rij) {
        var qEl = rij.querySelector('.syk-vrd-q');
        if (!qEl) return; /* uitverkochte rij: geen kiezer, telt niet mee */
        var q = parseInt(qEl.value, 10) || 0;
        totaal += q;
        var sku = rij.getAttribute('data-sku');
        var t = STAFFEL[sku] || [];
        var d;
        if (rij.classList.contains('syk-vrd-rij--pre')) {
          /* pre-order: de leverancier kent geen staffel, de verwachte datum komt uit het metafield.
             Die telt WEL mee in de leverdatum van de hele bestelling — alles gaat in één zending. */
          d = verwachtDatum(sku);
        } else {
          d = q > 0 ? tierDate(t, q) : (t[0] && t[0].deliveryDate ? new Date(t[0].deliveryDate) : null);
        }
        /* boven de hoogste trap geeft tierDate null; val dan terug op de LAATSTE staffeldatum in
           plaats van 'geen datum' — anders zou de bestelling er sneller uitzien dan hij is */
        if (q > 0 && !d && t.length && t[t.length - 1].deliveryDate) d = new Date(t[t.length - 1].deliveryDate);
        /* Groen = de SNELST MOGELIJKE datum voor dit product (kolom 1), oranje = de latere kolom.
           Eerder vergeleken we met 'morgen' (isFastest). Fout bij producten met een andere cutoff:
           daar is de eerste leverdatum bijvoorbeeld vrijdag, en dan kleurde ELKE rij oranje terwijl
           het gewoon de snelste optie is (melding eigenaar 30-09). Nu is de eerste kolom de maatstaf. */
        /* alleen markeren als er ECHT staffeldata is. Zonder data (leverancier kent deze maat niet;
           gemeten 30-09 gaven L en XL zowel [] als deliveryDate:null) stond de lege kolom eerst tóch
           groen — dat belooft een levertijd die we niet kennen. Nu blijven beide kolommen neutraal. */
        var heeftData = t.length > 0;
        /* null-veilig: een ontbrekende kolomcel wierp een TypeError en legde daarmee de HELE
           herberekening plat (knop bleef op 0 staan). Getest 30-09 met een rij zonder kolomcellen. */
        /* Welke kolom licht op? Bij een gekozen aantal de kolom van de datum die daarbij hoort; bij
           0 stuks de kolom waar deze maat het EERST leverbaar is. Voorheen lichtte bij 0 stuks altijd
           kolom 1 op, ook als deze maat daar een streepje had (na 15:00 bijv. M zonder eigen
           voorraad) — een groene vlek op 'niets'. Groen = eerste kolom, oranje = een latere. */
        var cellen = [rij.querySelector('.syk-vrd-n1'), rij.querySelector('.syk-vrd-n2'), rij.querySelector('.syk-vrd-n3')];
        if (!rij.classList.contains('syk-vrd-rij--pre')) {
          var refD = (q > 0 && d) ? d : (t[0] && t[0].deliveryDate ? new Date(t[0].deliveryDate) : null);
          var ki = kolIndex(refD);
          cellen.forEach(function (c, i) { if (c) c.classList.toggle('actief', heeftData && i === ki); });
        }
        if (q > 0) { if (rij.classList.contains('syk-vrd-rij--pre')) aantalPre += q; else aantalVoorraad += q; }
        if (q > 0 && d && (!traagste || d > traagste)) traagste = d;
        /* Welke cutoff geldt voor DEZE regel? Trap 0 = eigen voorraad -> de algemene tijd;
           trap 1+ = bij de leverancier bestellen -> de merktijd. Van alle gekozen maten houden
           we de strengste over: elk artikel moet zijn eigen besteldag halen. */
        if (q > 0 && cutAan && CUTOFF && !rij.classList.contains('syk-vrd-rij--pre')) {
          var ti = tierIndex(t, q);
          /* Trap 1+ hoort bij de LEVERANCIER, en dan hebben we de tijd van dit merk nodig. Staat het
             merk niet in het bestand, dan zouden we terugvallen op 'default' — maar dat is de tijd
             van de EIGEN voorraad (23:59) en die zegt niets over deze leverancier. Dan liever
             zwijgen dan een deadline verzinnen. */
          var reg = null;
          if (ti === 0 && d && diffDays(d) <= 0) {
            /* leverdatum VANDAAG = avondlevering: dan geldt de vaste besteltijd daarvan (10:45) */
            reg = { cutoff: VD.tijd, werkdagen: (CUTOFF['default'] || {}).werkdagen };
          } else if (ti === 0) {
            reg = CUTOFF['default'] || null;
            /* VOLGENDE-DAG-LEVERANCIER (gemeten 05-10 rond 15:00 op het Hulk-shirt): vóór zijn
               besteltijd telt econcepts de voorraad van zo'n leverancier mee in de MORGEN-trap,
               samen met de eigen voorraad (S: 1 eigen + 11 Finidi = 12 'morgen'). Om 15:00 schuift
               het Finidi-deel naar overmorgen. Tot dat moment kunnen we de twee niet uit elkaar
               halen, dus geldt voor de hele morgen-trap de besteltijd van het merk: die is voor elk
               stuk waar (ook een stuk uit eigen voorraad haalt 'vóór 15:00'). Na de besteltijd is de
               morgen-trap weer puur eigen voorraad en geldt de algemene tijd vanzelf weer. */
            var mReg = CUTOFF[vendor], mMin = mReg ? minutenVan(mReg.cutoff) : null, aMin = reg ? minutenVan(reg.cutoff) : null;
            if (merkVolgdag && klok && mMin !== null && klok.min < mMin && (aMin === null || mMin < aMin)) reg = mReg;
          }
          else if (ti >= 1) reg = CUTOFF[vendor] || null;
          var mn = reg ? minutenVan(reg.cutoff) : null;
          if (mn !== null && d) kand.push({ d: d, mn: mn, txt: reg.cutoff, lev: ti >= 1, werk: (reg.werkdagen && reg.werkdagen.length) ? reg.werkdagen : null });
        }
      });
      /* Welke besteltijd BINDT de hele bestelling? Alles gaat in één zending op de traagste datum.
         Alleen de maten die op díe datum uitkomen bepalen dus de besteltijd: een maat die eerder
         klaar is, heeft speling (mist hij zijn eigen tijd, dan schuift hij één werkdag op en haalt
         de traagste datum nog steeds). Voorbeeld 06-10 's ochtends: S uit eigen voorraad vandaag
         (10:45) + M morgen (23:59) -> de bestelling komt morgen, dus 23:59, niet 10:45.
         Van die maten de strengste; bij gelijke tijd wint de leverancier-regel. */
      kand.forEach(function (k) {
        if (!traagste || sod(k.d).getTime() !== sod(traagste).getTime()) return;
        if (cutMin === null || k.mn < cutMin || (k.mn === cutMin && k.lev && !cutLev)) {
          cutMin = k.mn; cutTxt = k.txt; cutLev = k.lev; cutWerk = k.werk;
        }
      });
      var tot = paneel.querySelector('.syk-vrd-tot');
      /* zelfde maatstaf als de kolommen: morgen is nooit 'laat', ook niet als hij niet de eerste kolom is */
      var laatTot = traagste && kolom1 && sod(traagste).getTime() > sod(kolom1).getTime() && diffDays(traagste) > 1;
      /* De cutoff-zin ('Voor 23:59 uur besteld = …') alleen gebruiken bij vandaag/morgen, want
         daar gáát die belofte over. Bij een latere datum klopt hij niet per se: sommige producten
         hebben een andere cutoff (melding eigenaar 30-09: 15:00-16:30), en dan zou 'voor 23:59
         besteld' een levering beloven die we niet waar kunnen maken. Dan tonen we alleen de datum. */
      var totZin = '';
      if (traagste) {
        var dg = diffDays(traagste);
        /* Staat de cutoff-regel aan (en is het bestand binnen), dan draagt DIE de besteltijd. De
           vaste 'Voor 23:59 uur besteld = ' hier zou hem anders tegenspreken: gemeten met de klok op
           14:30 stond er 'Voor 23:59 uur besteld = morgen in huis' boven 'Besteld vóór 15:00?'.
           Dan hier alleen de datum. Staat de regel uit, dan blijft de oude zin zoals hij was. */
        var metCut = cutAan && CUTOFF;
        if (dg <= 0 && vandaagNogMogelijk()) {
          /* vandaag = avondlevering: 'Vanavond in huis', of zonder cutoff-regel de hele zin met 10:45 */
          totZin = metCut ? VD.kort : vandaagTekst();
        } else {
          var dTot = dg <= 0 ? nextBusinessDay() : traagste; /* besteltijd vandaag voorbij */
          var dg2 = diffDays(dTot);
          totZin = (dg2 <= 1 && !metCut) ? (CFG.fast || '') + inHuis(dTot).toLowerCase() : cap(inHuis(dTot));
        }
      }
      tot.textContent = totZin;
      tot.className = 'syk-vrd-tot' + (traagste ? (laatTot ? ' laat' : ' snel') : '');
      /* CUTOFF-REGEL (endpoint eigenaar 30-09). Twee toestanden, allebei alleen getoond wanneer
         ze iets WAARS zeggen:
         - nog open  -> alleen als de bestelling vandaag/morgen zou komen; daar gaat de besteldag over.
         - al dicht  -> alleen als dit aantal ECHT bij de leverancier vandaan moet (trap 1+). Dan is
                        die besteldag aantoonbaar weg (min(a,b) <= a). Ligt het op eigen voorraad,
                        dan zegt een gesloten leveranciersdag niets en zou de zin de datum erboven
                        tegenspreken. De zin gaat bewust over onze VERWERKING, niet over bezorging:
                        de verzendmethode-tijden zitten niet in dit bestand. */
      var cutEl = paneel.querySelector('.syk-vrd-cut');
      if (cutEl) {
        var cutZin = '';
        /* Zit er een pre-order bij, dan bepaalt die de datum en is een besteldeadline van vandaag
           niet het verhaal; de voet legt pre-order al apart uit. */
        if (klok && cutTxt && aantalPre === 0) {
          /* Relevant? Bij trap 1+ altijd (de deadline bepaalt welke leveranciersrun je haalt).
             Bij eigen voorraad alleen als de bestelling vandaag/morgen zou komen — naast een datum
             van twaalf dagen verderop (gemeten bij Wicked Costumes) zegt hij niets. */
          var relevant = cutLev || (traagste && diffDays(traagste) <= 1);
          /* Is het vandaag een besteldag? Zo niet (zaterdag/zondag) dan is er geen run om te halen
             en zou 'vandaag nog in behandeling' onwaar zijn. werkdagen komt uit de feed zelf. */
          var werkdagVandaag = !cutWerk || cutWerk.indexOf(klok.dag) > -1;
          /* Alleen tonen zolang er een besteltijd OPEN staat waar de klant iets aan heeft (keuze
             eigenaar 05-10: 'De besteldag sloot vandaag om 15:00…' was niet sterk — negatief, en de
             datum erboven zegt het al). Na de besteltijd en in het weekend dus geen regel; dan
             spreekt alleen de datum. De teksten cutdicht/cutweekend blijven in de snippet staan
             (ongebruikt), zodat ze zonder snippet-plak terug kunnen als de eigenaar dat wil. */
          if (relevant && werkdagVandaag && klok.min < cutMin) cutZin = (T.cutopen || '').replace('{t}', tijdTekst(cutTxt));
        }
        cutEl.textContent = cutZin;
        cutEl.hidden = !cutZin;
      }
      /* DRIE TOESTANDEN (ontwerp eigenaar 30-09):
         1. alleen voorraad  -> witte voet, groene datum, 'Alle geselecteerde artikelen zijn op voorraad.'
         2. met pre-order    -> zacht getinte voet, oranje datum, 'Bevat een pre-order artikel' + uitleg
         3. mix              -> idem als 2, plus de kaart 'Op voorraad artikelen eerder ontvangen?' */
      var voet = paneel.querySelector('.syk-vrd-voet');
      if (voet) {
        voet.classList.toggle('leeg', !traagste);
        voet.classList.toggle('met-pre', aantalPre > 0);
        var sub = voet.querySelector('.syk-vrd-sub');
        if (sub) {
          if (!traagste) sub.innerHTML = '';
          else if (aantalPre > 0) {
            sub.innerHTML = '<button type="button" class="syk-vrd-preinfo syk-vrd-subinfo" aria-label="' + vrdEsc(T.pretitel) + '" aria-expanded="false">' +
              '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/><path d="M12 11v5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="7.8" r="1.15" fill="currentColor"/></svg></button>' +
              vrdEsc(T.bevat) +
              '<span class="syk-vrd-tip" hidden><b>' + vrdEsc(T.pretitel) + '</b><span>' + vrdEsc(subUitleg()) + '</span>' +
              '<button type="button" class="syk-vrd-tipx" aria-label="Sluiten"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></button></span>';
          } else sub.textContent = T.alles;
        }
        var eerder = voet.querySelector('.syk-vrd-eerder');
        if (eerder) {
          eerder.hidden = !(aantalPre > 0 && aantalVoorraad > 0);
          if (!eerder.hidden) {
            /* met de ECHTE snelste datum erin wordt de afweging pas concreet: 'dan heb je die al
               vrijdag 2 oktober in huis' zegt meer dan 'bestel deze als losse bestelling'. */
            var iT = eerder.querySelector('i');
            if (iT) iT.textContent = kolom1 ? (T.etekst || '').replace('{d}', dateLong(kolom1)) : (T.etekstg || '');
          }
        }
      }
      var cta = paneel.querySelector('.syk-vrd-cta');
      cta.disabled = totaal < 1;
      cta.textContent = T.cta + (totaal ? ' (' + totaal + ' ' + T.stuks + ')' : '');
    }
    function inWinkelwagen() {
      var items = [];
      rijen.forEach(function (rij) {
        var qEl = rij.querySelector('.syk-vrd-q'); if (!qEl) return;
        var vid = rij.getAttribute('data-id');
        /* dubbel slot (wens eigenaar 30-09: 'uitverkocht mag niet besteld worden tot pre-order live
           is'): een uitverkochte rij heeft geen kiezer én geen variant-id, en we controleren hier
           bovendien nog in VARS of de variant echt leverbaar is. */
        if (!vid) return;
        var vv = VARS.filter(function (x) { return String(x.id) === String(vid); })[0];
        if (!vv || vv.available === false) return;
        var q = parseInt(qEl.value, 10) || 0;
        if (q > 0) items.push({ id: vid, quantity: q });
      });
      if (!items.length) return;
      var cta = paneel.querySelector('.syk-vrd-cta'); cta.disabled = true;
      addToCartAjax(items, function () { sluit(); location.href = '/cart'; }, function () { cta.disabled = false; });
    }
    function open() {
      if (!paneel) bouw();
      paneel.classList.add('open');
      document.documentElement.classList.add('syk-vrd-lock');
      vulTabel();                                  /* meteen zichtbaar, ook zonder data */
      if (!haalBezig) haalBezig = haalStaffels(vulGetallen);
      else haalBezig.then(vulGetallen);
      haalBezig.then(function () { if (paneel.classList.contains('open')) vulGetallen(); });
      /* Cutoff OOK hier ophalen, niet alleen in voorverwarm(): dat hangt aan hover/touch, dus een
         bezoeker die met het toetsenbord opent zou de regel nooit zien. En opnieuw doorrekenen bij
         elke opening: een tab die over de deadline heen open blijft staan toonde anders nog
         'Besteld vóór 09:00?' terwijl het al 10:00 is. cutoffLaad() hergebruikt zijn eigen cache. */
      if (cutAan) cutoffMetTest().then(function () { if (paneel && paneel.classList.contains('open')) herbereken(); });
    }
    function sluit() {
      if (!paneel) return;
      paneel.classList.remove('open');
      document.documentElement.classList.remove('syk-vrd-lock');
      trigger.focus();
    }
    trigger.addEventListener('pointerenter', voorverwarm);
    trigger.addEventListener('touchstart', voorverwarm, { passive: true });
    trigger.addEventListener('click', open);
    $all('.syk-vrd-link').forEach(function (b) { if (b !== trigger) b.addEventListener('click', open); });
  })();

})();
